import React, { useCallback, useEffect, useState } from "react";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Spinner from "../../component/loadingbar/Spinner";
import { triggerNotification } from "../../component/message/Msg";
import config from "../../config";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import DropZone from "../../component/dropzone/DropZone";
import Tags from "@yaireo/tagify/dist/react.tagify";
import { set } from "react-hook-form";
import "mathlive";
import MathFormulaViewer from "../../component/mathformula/MathFormulaViewer";
import Swal from "sweetalert2";

const AddMcq = () => {
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();
  const from = query.get("type");
  let title = from == "mcq" ? "Add MCQ" : "Add Exam MCQ";
  const { base, id, mcqid, upfrom, adfrom, cfa, snm, mbid, mbidForEdit } =
    useParams();
  const token = config.token;
  const navigate = useNavigate();
  useLocation();

  //------------------------------- state management -----------------------------------
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedChapter, setSelectedChapter] = useState("");
  const [isCourseDropdownOpen, setIsCourseDropdownOpen] = useState(false);
  const [isChapterDropdownOpen, setIsChapterDropdownOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mcqBanks, setMcqBanks] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [courses, setCourses] = useState([]);
  const [screenInWidth, setScreenInWidth] = useState(
    Math.round(window.innerWidth / 12.1)
  );
  const [instruction, setInstruction] = useState("");
  const [optNumValue, setOptNumValue] = useState();
  const [optSelectValue, setOptSelectvalue] = useState("any");
  const [enableOpt, setEnableOpt] = useState(null);
  const [sectionList, setSectionList] = useState([]);
  const [sectionValue, setSectionValue] = useState("");
  const [mcqMarks, setMcqMarks] = useState("");
  const [commonMcqMarks, setCommonMcqMarks] = useState("");
  const [commonNegativeMcqMarks, setCommonNagativeMcqMarks] = useState("");
  const [expainationFileVal, setExpainationFileVal] = useState([]);
  const [queFileVal, setQueFileVal] = useState([]);
  const [optFileVal, setOptFileVal] = useState([]);
  const [previousYear, setPreviousYear] = useState([]);
  const [negativeMarks, setNegativeMarks] = useState("");
  const [courseWiseQue, setCourseWiseQue] = useState(true);
  const [selectedChapterOrCourseOption, setSelectedChapterOrCourseOption] =
    useState("");
  const [selectedMcqBank, setSelectedMcqBank] = useState("");
  const [questions, setQuestions] = useState([]);
  const [timer, setTimer] = useState({
    set_timer: false,
    timer: "",
  });
  const [selectedMcqQuestions, setSelectedMcqQuestions] = useState([]);
  const [selectAllMcq, setSelectAllMcq] = useState(false);
  const [hasRemainingMcqs, setHasRemainingMcqs] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setScreenInWidth(Math.round(window.innerWidth / 12.1));
    };

    window.addEventListener("resize", handleResize);

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    console.log("optFileVal: ", optFileVal);
  }, [optFileVal]);

  const validateMath = (content) => {
    if (content.includes("\\placeholder")) {
      return false;
    } else {
      return true;
    }
  };
  // --------------------------------------------------- btn handle question or option change ---------------------------------------------------
  //handle question change
  const handleQuestionChange = (section, questionIndex, property, value) => {
    const newQuestions = { ...questions };


    if (property === "wordIncludeList" || property === "wordNotIncludeList") {
      newQuestions[section][questionIndex][property] =
        value.detail.tagify.value.map((a) => a.value);
    } else if (property === "isFormula") {
      newQuestions[section][questionIndex][property] =
        !newQuestions[section][questionIndex][property];
      newQuestions[section][questionIndex]["question"] = "";
      newQuestions[section][questionIndex]["isFormulaValid"] = true;
    } else if (property === "explanation_file") {
      newQuestions[section][questionIndex][property] = value.target.files[0];
    } else if (property === "que_file") {
      newQuestions[section][questionIndex][property] = value.target.files[0];
    } else if (property === "difficulty") {
      console.log("difficulty");

      newQuestions[section][questionIndex][property] = value;
    } else {
      if (newQuestions[section][questionIndex]["isFormula"]) {
        newQuestions[section][questionIndex]["isFormulaValid"] =
          validateMath(value);
      }
      newQuestions[section][questionIndex][property] = value;
    }
    if (property === "que_type") {
      newQuestions[section][questionIndex]["answer"] = "";
      newQuestions[section][questionIndex]["explanation"] = "";
      newQuestions[section][questionIndex]["explanation_file"] = "";
      newQuestions[section][questionIndex]["match"] =
        value === "Match the pair" || value === "Match the pair With Option"
          ? [
            {
              left: "",
              right: "",
              isFormula: false,
              isLeftFormulaValid: true,
              isRightFormulaValid: true,
            },
            {
              left: "",
              right: "",
              isFormula: false,
              isLeftFormulaValid: true,
              isRightFormulaValid: true,
            },
          ]
          : [];
      newQuestions[section][questionIndex]["options"] =
        value === "Short"
          ? []
          : [
            {
              isFormula: false,
              optTxt: "",
              isFormulaValid: true,
              option_file: "",
            },
            {
              isFormula: false,
              optTxt: "",
              isFormulaValid: true,
              option_file: "",
            },
          ];

      newQuestions[section][questionIndex]["multipleChoice"] =
        value == "Multiple Choice" ? ["", ""] : [];
    }
    if (property === "prv_year") {
      setPreviousYear((prev) => {
        const updatedYear = [...prev];
        updatedYear[questionIndex] = value;
        return updatedYear;
      });
    }
    setQuestions(newQuestions);
  };

  //handle question change //delete this
  // const handleIsFormulaChange = (section, questionIndex, property, value) => {
  //   const newQuestions = { ...questions };

  //   if (property === "wordIncludeList" || property === "wordNotIncludeList") {
  //     newQuestions[section][questionIndex][property] =
  //       value.detail.tagify.value.map((a) => a.value);
  //   } else if (property === "explanation_file") {
  //     newQuestions[section][questionIndex][property] = value.target.files[0];
  //   } else {
  //     newQuestions[section][questionIndex][property] = value;
  //   }
  //   if (property === "que_type") {
  //     newQuestions[section][questionIndex]["answer"] = "";
  //     newQuestions[section][questionIndex]["explanation"] = "";
  //     newQuestions[section][questionIndex]["explanation_file"] = "";
  //     newQuestions[section][questionIndex]["options"] =
  //       value === "Match the pair"
  //         ? [
  //             { left: "", right: "" },
  //             { left: "", right: "" },
  //           ]
  //         : value === "Short"
  //         ? []
  //         : ["", ""];
  //   }
  //   setQuestions(newQuestions);
  // };

  //handle option change
  const handleOptionChange = async (
    e,
    section,
    questionIndex,
    optionIndex,
    dropdownIndex
  ) => {
    const { value, type, name, files } = e.target;
    const v = e.target.value;
    console.log(`Dropdown Index: ${dropdownIndex}, Selected Value: ${v}`);
    console.log("~~~~~~~~~", e.target.checked, value, type, name);
    // Create a copy of the questions object
    const updatedQuestions = { ...questions };
    console.log(questions[section][questionIndex]);
    // if (updatedQuestions[section][questionIndex].que_type === "Fill In The Blanks With Combo") {
    //   const selectedOptions = updatedQuestions[section][questionIndex].selectedOptions || [];

    //   // Update the specific dropdown value
    //   selectedOptions[dropdownIndex] = value;
    //   updatedQuestions[section][questionIndex].selectedOptions = selectedOptions;

    //   console.log("Updated Selected Options: ", selectedOptions);
    //   // You should set the state here if using state management
    //   // e.g., setQuestions(updatedQuestions); or similar
    // }

    if (updatedQuestions[section][questionIndex].que_type === "True/False") {
      updatedQuestions[section][questionIndex].options = [
        {
          isFormula: false,
          optTxt: "true",
          isFormulaValid: true,
          option_file: "",
        },
        {
          isFormula: false,
          optTxt: "false",
          isFormulaValid: true,
          option_file: "",
        },
      ];
    }

    if (type === "radio") {
      updatedQuestions[section][questionIndex].answer =
        updatedQuestions[section][questionIndex].options[optionIndex].optTxt;
    } else if (type === "checkbox") {
      console.log("Call CheckBox");
      if (
        updatedQuestions[section][questionIndex].options[optionIndex].optTxt !=
        ""
      ) {
        updatedQuestions[section][questionIndex].multipleChoice[optionIndex] = e
          .target.checked
          ? updatedQuestions[section][questionIndex].options[optionIndex].optTxt
          : "";
      }
      let temp = [];
      for (
        let mi = 0;
        mi < updatedQuestions[section][questionIndex].multipleChoice.length;
        mi++
      ) {
        let mv = updatedQuestions[section][questionIndex].multipleChoice[mi];
        if (mv !== undefined && mv.length > 0) {
          temp.push(mv);
        }
      }
      // updatedQuestions[section][questionIndex].multipleChoice.map((m)=>{
      //   if(m && m.length>0 && m!==undefined){
      //     return m
      //   }
      // });
      console.log(
        "temp.length",
        temp,
        temp.length,
        updatedQuestions[section][questionIndex].multipleChoice
      );

      updatedQuestions[section][questionIndex].answer =
        temp.length > 0 ? (temp.length > 1 ? temp.join(",") : temp[0]) : "";
    } else {
      if (name === "left") {
        if (
          updatedQuestions[section][questionIndex].match[optionIndex][
          "isFormula"
          ]
        ) {
          updatedQuestions[section][questionIndex].match[optionIndex][
            "isLeftFormulaValid"
          ] = validateMath(value);
        }

        updatedQuestions[section][questionIndex].match[optionIndex].left =
          value;
        if (
          questions[section][questionIndex]["que_type"] !=
          "Match the pair With Option"
        ) {
          updatedQuestions[section][questionIndex].answer = updatedQuestions[
            section
          ][questionIndex].match
            ?.map((item) => `${item.left}@#$${item.right}`)
            .join("$#@");
        }
      } else if (name === "right") {
        if (
          updatedQuestions[section][questionIndex].match[optionIndex][
          "isFormula"
          ]
        ) {
          updatedQuestions[section][questionIndex].match[optionIndex][
            "isRightFormulaValid"
          ] = validateMath(value);
        }

        updatedQuestions[section][questionIndex].match[optionIndex].right =
          value;

        if (
          questions[section][questionIndex]["que_type"] !=
          "Match the pair With Option"
        ) {
          updatedQuestions[section][questionIndex].answer = updatedQuestions[
            section
          ][questionIndex].match
            ?.map((item) => `${item.left}@#$${item.right}`)
            .join("$#@");
        }
      } else if (name === "optTxt") {
        if (
          updatedQuestions[section][questionIndex].options[optionIndex][
          "isFormula"
          ]
        ) {
          updatedQuestions[section][questionIndex].options[optionIndex][
            "isFormulaValid"
          ] = validateMath(value);
        }

        updatedQuestions[section][questionIndex].options[optionIndex].optTxt =
          value;
        if (
          updatedQuestions[section][questionIndex].que_type ===
          "Fill In The Blanks With Combo"
        ) {
          updatedQuestions[section][questionIndex].multipleChoice = Array.from(
            {
              length: (
                updatedQuestions[section][questionIndex].question.match(
                  /{dash}/g
                ) || []
              ).length,
            },
            () => ""
          );
          let temp = [];

          for (
            let mi = 0;
            mi < updatedQuestions[section][questionIndex].multipleChoice.length;
            mi++
          ) {
            let mv =
              updatedQuestions[section][questionIndex].multipleChoice[mi];
            if (mv !== undefined && mv.length > 0) {
              temp.push(mv);
            }
          }
          updatedQuestions[section][questionIndex].answer =
            temp.length > 0 ? (temp.length > 1 ? temp.join(",") : temp[0]) : "";
        }
        console.log(
          "updatedQuestions[section][questionIndex].multipleChoice",
          updatedQuestions[section][questionIndex].multipleChoice
        );

        // updatedQuestions[section][questionIndex].multipleChoice[optionIndex]=""
      } else if (name === "option_file") {
        updatedQuestions[section][questionIndex].options[
          optionIndex
        ].option_file = files[0];
        // console.log("files: ", files[0]);
        // console.log(name);
      } else if (name == "drop-down") {
        console.log("dropdown on change", value);

        if (value != "") {
          updatedQuestions[section][questionIndex].multipleChoice[optionIndex] =
            value;
        }
        let temp = [];
        for (
          let mi = 0;
          mi < updatedQuestions[section][questionIndex].multipleChoice.length;
          mi++
        ) {
          let mv = updatedQuestions[section][questionIndex].multipleChoice[mi];
          if (mv !== undefined && mv.length > 0) {
            temp.push(mv);
          }
        }
        // updatedQuestions[section][questionIndex].multipleChoice.map((m)=>{
        //   if(m && m.length>0 && m!==undefined){
        //     return m
        //   }
        // });
        console.log(
          "temp.length",
          temp,
          temp.length,
          updatedQuestions[section][questionIndex].multipleChoice
        );

        updatedQuestions[section][questionIndex].answer =
          temp.length > 0 ? (temp.length > 1 ? temp.join(",") : temp[0]) : "";
      } else {
        //toggle isFormula
        updatedQuestions[section][questionIndex].options[
          optionIndex
        ].isFormula =
          !updatedQuestions[section][questionIndex].options[optionIndex]
            .isFormula;

        //clean optTxt
        updatedQuestions[section][questionIndex].options[optionIndex].optTxt =
          "";
        updatedQuestions[section][questionIndex].options[
          optionIndex
        ].option_file = "";
        updatedQuestions[section][questionIndex].options[optionIndex].left = "";
        updatedQuestions[section][questionIndex].options[optionIndex].right =
          "";

        // isFormulaValid = true
        updatedQuestions[section][questionIndex].options[
          optionIndex
        ].isFormulaValid = true;
        updatedQuestions[section][questionIndex].options[
          optionIndex
        ].isRightFormulaValid = true;
        updatedQuestions[section][questionIndex].options[
          optionIndex
        ].isLeftFormulaValid = true;
      }
    }

    if (updatedQuestions[section][questionIndex].que_type === "Orders") {
      updatedQuestions[section][questionIndex].answer = await updatedQuestions[
        section
      ][questionIndex]?.options
        .map((opt) => opt.optTxt)
        .join(",");
    }

    // Update the state with the new questions object
    setQuestions(updatedQuestions);
  };

  //handle SectionVal Change
  const handleSectionValChange = (e) => {
    setSectionValue(e.target.value);
  };

  //handle McqMark Change
  const handleMcqMarkChange = (e) => {
    setMcqMarks(e.target.value);
  };

  //handle NegativeMark Change
  const handleNegativeMarkChange = (e) => {
    setNegativeMarks(e.target.value);
  };
  // const handleCommonMcqMarkChange = (e) => {
  //   setCommonMcqMarks(e.target.value);
  // };

  //handle NegativeMark Change
  // const handleCommonNegativeMarkChange = (e) => {
  //   setCommonNagativeMcqMarks(e.target.value);
  // };

  //handle timer
  const handleTimerBtn = () => {
    setTimer((prevData) => ({
      ...prevData,
      set_timer: !timer.set_timer,
    }));
  };

  const handleOptinalBtn = () => {
    setEnableOpt((prev) => (prev === 1 ? 0 : 1));
  }

  const handleOptChange = (e) => {
    setOptSelectvalue(e.target.value);
  };


  //handle timer value
  const timerValueChange = (e) => {
    setTimer((prevData) => ({
      ...prevData,
      timer: e.target.value,
    }));
  };

  //-------------------------------------- clear form data --------------------------------------r
  const clearForm = () => {
    setSelectedMcqBank("");
    setSelectedChapterOrCourseOption("");
    setQuestions([]);

    if (id !== undefined && base !== undefined) {
      navigate(`/viewmcqs/${base}/${id}/${adfrom}`);
    } else if (id !== undefined) {
      navigate(`/viewmcqs/${upfrom}/${id}/${adfrom}`);
    } else {
      // navigate("/addmcq");
      window.location.reload();
    }
  };

  //if id
  useEffect(() => {
    if (id !== undefined) {
      setSelectedChapterOrCourseOption(decodeURIComponent(atob(id)));
    }
  }, [id]);

  //fetch data
  useEffect(() => {
    setLoading(false);
    setMcqBanks([]);
    setChapters([]);
    setCourses([]);

    setSectionList([]);
    setSectionValue("");
    setMcqMarks("");
    setCommonMcqMarks("");
    setCommonNagativeMcqMarks("");
    setExpainationFileVal([]);
    setQueFileVal([]);
    setOptFileVal([]);
    setPreviousYear([]);
    setNegativeMarks("");
    setCourseWiseQue(true);
    setSelectedChapterOrCourseOption("");
    setSelectedMcqBank("");
    setQuestions([]);

    setTimer({
      set_timer: false,
      timer: "",
    });

    // Fetch course list
    fetch(`${config.host_url}course`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          setCourses(data.data);
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching media:", error);
      });

    // Fetch chapter list
    fetch(`${config.host_url}chapter`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          setChapters(data.data);
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching media:", error);
      });

    if (mbid) {
      setSelectedMcqBank(atob(decodeURIComponent(mbid)));
    }
    setSelectedMcqBank(selectedMcqBank);
    getQuestions(selectedMcqBank);
  }, [token, window.location.pathname, useLocation()]);
  const reloadData = (id) => {
    console.log({ id });
  };

  const getQuestions = (id) => {
    if (selectedChapterOrCourseOption) {
      try {
        fetch(`${config.host_url}mcq?mbid=${id}&from=${from}`, {
          method: "GET",
          headers: {
            token: token,
          },
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.status === 200) {
              const sectionListData = data.sections?.map((section, i) => ({
                section: section,
                section_mark: data.section_mark[i],
                section_negative_marks: data.section_negative_marks[i],
                set_timer: data.set_timer[i] === 1 ? true : false,
                timer: data.timer[i],
              }));
              setSectionList(sectionListData);

              const quesData = {};
              const allImages = [];
              const allQueFiles = [];
              const allOptFiles = [];
              const previousYears = [];
              sectionListData.forEach((sectionItem) => {
                const section = sectionItem.section;
                const sectionQuestions = data.data[section]?.map((que) => {
                  let mappedQuestion = {
                    difficulty: que.difficulty,
                    isEditable: que.isEditable,
                    wordIncludeList:
                      que.word_include != null
                        ? que.word_include?.split("@#$")
                        : [],
                    wordNotIncludeList:
                      que.word_not_include != null
                        ? que.word_not_include?.split("@#$")
                        : [],
                    qid: que.mcqid,
                    mark: que.positive_mark,
                    negativeMark: que.negative_mark,
                    answer: que.ans,
                    explanation: que.explanation,
                    isFormula: que.isFormula === 1 ? true : false,
                    isFormulaValid: true,
                    isLeftFormulaValid: true,
                    isRightFormulaValid: true,
                    explanation_file: que.explanation_file,
                    que_type: que.que_type,
                    question: que.que,
                    que_file: que.que_file,
                    sections: sectionItem,
                    prv_year: que.prv_year,
                  };
                  previousYears.push(que.prv_year);
                  allImages.push(mappedQuestion.explanation_file);
                  allQueFiles.push(mappedQuestion.que_file);
                  let tempAns = que.ans.length > 0 ? que.ans.split(",") : [];
                  if (que.options?.length > 1) {
                    mappedQuestion.multipleChoice = [];
                    let result = [];
                    que.options.map((opt, index) => {
                      result.push({
                        optTxt:
                          que.que_type === "True/False"
                            ? index === 0
                              ? "true"
                              : "false"
                            : opt,
                        option_file: que.options_file[index]
                          ? que.options_file[index]
                          : "",
                        isFormula:
                          que.options_formula[index] === "1" ? true : false,
                        isFormulaValid: true,
                      });
                      if (tempAns.indexOf(opt) !== -1) {
                        mappedQuestion.multipleChoice.push(opt);
                      }
                    });
                    mappedQuestion.options = result;

                    allOptFiles.push(result.map((opt) => opt.option_file));
                  }
                  if (
                    que.que_type === "Match the pair" ||
                    que.que_type === "Match the pair With Option"
                  ) {
                    const result = que.left_side.map((leftValue, index) => ({
                      left: leftValue,
                      right: que.right_side[index],
                      isFormula:
                        que.options_formula[index] === "1" ? true : false,
                      isRightFormulaValid: true,
                      isLeftFormulaValid: true,
                    }));
                    mappedQuestion.match = result;

                    allOptFiles.push("");
                  }

                  return mappedQuestion;
                });
                quesData[section] = sectionQuestions;
              });
              setExpainationFileVal(allImages);
              setQueFileVal(allQueFiles);
              setOptFileVal(allOptFiles);
              setPreviousYear(previousYears);
              console.log("allOptFiles: ", allOptFiles);
              const updatedQuestions = { ...quesData };
              Object.keys(updatedQuestions).forEach((key) => {
                if (updatedQuestions[key] === undefined) {
                  updatedQuestions[key] = [];
                }
              });
              setQuestions(updatedQuestions);
            } else if (data.status === 401) {
              triggerNotification("error", "Unauthenticated user");
            } else {
              triggerNotification(
                "error",
                "Internal server error, Please try after some time!!"
              );
            }
          });
      } catch (error) {
        triggerNotification("error", "Error fetching data");
      } finally {
        setLoading(false);
      }

    } else {

    }

  };

  useEffect(() => {
    if (base !== undefined) {
      //fetch mcq bank
      fetch(
        `${config.host_url}mcqbanks/${base}/${decodeURIComponent(atob(id))}`,
        {
          method: "GET",
          headers: {
            token,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setMcqBanks(data.data);
        });
      setLoading(false);
    }
  }, [base]);
  // --------------------------------------------------- btn Add section ---------------------------------------------------
  const handleAddSectionBtn = () => {
    if (sectionValue?.trim() === "") {
      triggerNotification(
        "error",
        "Section name is required to create a new section"
      );
      return;
    } else if (mcqMarks === null) {
      triggerNotification(
        "error",
        "MCQ mark is required to create a new section"
      );
      return;
    } else if (negativeMarks === null) {
      triggerNotification(
        "error",
        "MCQ negative mark is required to create a new section"
      );
      return;
    } else if (sectionValue.includes(" ")) {
      triggerNotification(
        "error",
        "Section names use underscores instead of spaces (e.g., hello_deepvecto)."
      );
      return;
    } else if (!/^\w+$/.test(sectionValue)) {
      triggerNotification(
        "error",
        "Section name should be a single word without special characters."
      );
      return;
    } else if (timer.set_timer && (timer.timer === "" || timer.timer === 0)) {
      triggerNotification(
        "error",
        "Please enter a valid timer or deselect the 'Set Timer' checkbox."
      );
      return;
    } else if (sectionList?.length >= 20) {
      triggerNotification(
        "error",
        "Sorry, You cannot add more than three sections."
      );
    }

    setSectionList((prevData) => [
      ...prevData,
      {
        section_mark: mcqMarks,
        section_negative_marks: negativeMarks,
        section: sectionValue,
        set_timer: timer.set_timer,
        timer: timer.timer,
        enableOpt: enableOpt,
        optSelectValue: optSelectValue,
        optNumValue: optNumValue,
        instruction: instruction
      },
    ]);
    setQuestions((question) => ({
      ...question,
      [sectionValue]: [],
    }));
    setTimer({
      set_timer: false,
      timer: "",
    });
    setSectionValue("");
    setMcqMarks("");
    setNegativeMarks("");
    setEnableOpt(0);
    setOptNumValue("");
    setOptSelectvalue("");
    setInstruction("");
  };

  // --------------------------------------------------- btn Add question or option ---------------------------------------------------
  //Add question
  const handleAddQuestionBtn = (sec) => {
    const newQuestions = { ...questions };
    const mark = commonMcqMarks ? commonMcqMarks : 1;
    const negativeMark = commonNegativeMcqMarks ? commonNegativeMcqMarks : 1;
    newQuestions[sec.section].push({
      qid: 0,
      isFormula: false,
      isFormulaValid: true,
      isRightFormulaValid: true,
      isLeftFormulaValid: true,
      word_include: "",
      word_not_include: "",
      question: "",
      que_file: "",
      explanation: "",
      explanation_file: "",
      sections: sec,
      // mark:1,
      // negativeMark:1,
      mark: mark,
      negativeMark: negativeMark,
      options: [],
      answer: "",
    });
    // Update the state with the new questions object
    setQuestions(newQuestions);
  };

  const handleCommonMcqMarkChange = (e) => {
    const newMark = e.target.value;
    setCommonMcqMarks(newMark);

    // Create a new object with updated mark values for all questions
    const updatedQuestions = { ...questions };

    for (const section in updatedQuestions) {
      updatedQuestions[section] = updatedQuestions[section].map((question) => ({
        ...question,
        mark: newMark,
      }));
    }

    setQuestions(updatedQuestions);
  };

  const handleCommonNegativeMarkChange = (e) => {
    const newNegativeMark = Number(e.target.value); // Convert to number if necessary
    setCommonNagativeMcqMarks(newNegativeMark);

    // Update all questions with the new common negative mark value
    const updatedQuestions = { ...questions };

    for (const section in updatedQuestions) {
      updatedQuestions[section] = updatedQuestions[section].map((question) => ({
        ...question,
        negativeMark: newNegativeMark,
      }));
    }

    setQuestions(updatedQuestions);
  };

  //Add option
  const handleAddOptionBtn = (section, questionIndex, mtp, mtpwo) => {
    const updatedQuestions = { ...questions };
    if (mtp) {
      updatedQuestions[section][questionIndex].match.push({
        left: "",
        right: "",
        isFormula: false,
      });
      if (mtpwo) {
        updatedQuestions[section][questionIndex].options.push({
          optTxt: "",
          isFormula: false,
          option_file: "",
        });
      }
    } else {
      updatedQuestions[section][questionIndex].options.push({
        optTxt: "",
        isFormula: false,
        option_file: "",
      });
    }
    setQuestions(updatedQuestions);
  };

  // --------------------------------------------------- btn Remove question or option ---------------------------------------------------
  //rmv question
  const handleRemoveQuestionBtn = (section, questionIndex) => {
    const newQuestions = { ...questions };

    newQuestions[section] = newQuestions[section].filter(
      (_, index) => index !== questionIndex
    );
    setQuestions(newQuestions);
  };

  //rmv option
  const handleRemoveOptionBtn = (section, questionIndex, optionIndex) => {
    const newQuestions = { ...questions };

    newQuestions[section] = newQuestions[section].map((question, idx) => {
      if (idx === questionIndex) {
        const updatedOptions = question.options.filter(
          (_, optIdx) => optIdx !== optionIndex
        );

        const updatedMultipleChoice = question.multipleChoice.filter(
          (opt) => opt !== question.options[optionIndex].optTxt
        );
        if (
          (question.que_type == "Fill In The Blanks With Combo",
            questionIndex,
            optionIndex)
        ) {
          console.log("call question.que_type ");
          console.log(question.multipleChoice);

          let temp = [];
          for (let mi = 0; mi < updatedMultipleChoice.length; mi++) {
            let mv = updatedMultipleChoice[mi];
            if (mv !== undefined && mv.length > 0) {
              temp.push(mv);
            }
          }
          question.answer =
            temp.length > 0 ? (temp.length > 1 ? temp.join(",") : temp[0]) : "";
        }
        return {
          ...question,
          options: updatedOptions,
          match: question.match?.filter((_, optIdx) => optIdx !== optionIndex),
          multipleChoice: updatedMultipleChoice,
        };
      }
      return question;
    });

    setQuestions(newQuestions);
  };

  // --------------------------------------------------- submit /create questions  ---------------------------------------------------C
  const handleSubmitBtn = async () => {
    try {
      const questionTexts = [];
      const isFormulaList = [];
      const optionTexts = [];
      const wordIncludeL = [];
      const wordNotIncludeL = [];
      const markAr = [];
      const negaMarkAr = [];
      const left = [];
      const right = [];
      const answers = [];
      const que_type = [];
      const difficulty = [];
      const explanationText = [];
      const explanationFileText = [];
      const queFileText = [];
      const optFileText = [];
      const optFormulaText = [];
      const sections = snm ? snm : [];
      const timer = [];
      const set_timer = [];
      const section_negative_marks = [];
      const section_mark = [];
      const qid = [];
      const prv_year = [];
      const optional_enable = [];
      const optional_for = [];
      const optional_number = [];
      const optional_instruction = [];

      Object.keys(questions).forEach((section) => {
        questions[section].forEach((question) => {
          console.log("question", question);

          //question
          questionTexts.push(question.question?.trim());
          isFormulaList.push(question.isFormula ? 1 : 0);
          prv_year.push(question.prv_year || "");
          //mark
          markAr.push(question.mark);

          //negative mark
          negaMarkAr.push(question.negativeMark);

          //explanation of que
          explanationText.push(question.explanation?.trim());

          //explanation_file  of que
          explanationFileText.push(question.explanation_file);

          //que_file  of que
          queFileText.push(question.que_file);

          //sections of que
          if (!snm) {
            sections.push(section);
          }
          set_timer.push(question.set_timer === true ? "1" : "0");
          timer.push(question.timer);
          qid.push(question.qid);
          section_mark.push(question.sections.section_mark || 1);
          section_negative_marks.push(question.sections.section_negative_marks || 0);
          optional_enable.push(question.sections.enableOpt || 0);
          optional_for.push(question.sections.optSelectValue || "");
          optional_number.push(question.sections.optNumValue || 0);
          optional_instruction.push(question.sections.instruction || "");

          //question type
          que_type.push(question.que_type);
          difficulty.push(question.difficulty);

          //include / notInclude
          // Updated part to handle wordIncludeList
          wordIncludeL.push(
            Array.isArray(question.wordIncludeList)
              ? question.wordIncludeList.join("@#$")
              : ""
          );
          wordNotIncludeL.push(
            Array.isArray(question.wordNotIncludeList)
              ? question.wordNotIncludeList.join("@#$")
              : ""
          );

          //options
          const optionTextArray = [];
          if (
            !(
              question.que_type === "Fill In The Blanks" ||
              question.que_type === "Short" ||
              question.que_type === "Match the pair"
            )
          ) {
            if (Array.isArray(question.options)) {
              question.options.forEach((opt) => {
                optionTextArray.push(opt.optTxt);
              });
            }
          }
          optionTexts.push(optionTextArray);

          //option_file  of que
          const optionFileArray = [];
          if (question.que_type === "Single Choice") {
            question.options.forEach((opt) => {
              optionFileArray.push(opt.option_file);
            });
          }
          optFileText.push(optionFileArray);
          console.log("optionFileArray: ", optionFileArray);

          //options_formula  of que
          const optionFormulaArray = [];
          if (
            question.que_type === "Single Choice" ||
            question.que_type === "Orders"
          ) {
            question.options.forEach((opt) => {
              optionFormulaArray.push(opt.isFormula ? "1" : "0");
            });
          } else if (
            question.que_type === "Match the pair" ||
            question.que_type === "Match the pair With Option"
          ) {
            if (Array.isArray(question.match)) {
              question.match.forEach((opt) => {
                optionFormulaArray.push(opt.isFormula ? "1" : "0");
              });
            }
          } else {
            if (Array.isArray(question.options)) {
              question.options.forEach((opt) => {
                optionFormulaArray.push("0");
              });
            }
          }
          optFormulaText.push(optionFormulaArray);

          //left
          const leftArray = [];
          if (
            question.que_type === "Match the pair" ||
            question.que_type === "Match the pair With Option"
          ) {
            if (Array.isArray(question.match)) {
              question.match.forEach((opt) => {
                leftArray.push(opt.left);
              });
            }
          }
          left.push(leftArray);

          //right
          const rightArray = [];
          if (
            question.que_type === "Match the pair" ||
            question.que_type === "Match the pair With Option"
          ) {
            if (Array.isArray(question.match)) {
              question.match.forEach((opt) => {
                rightArray.push(opt.right);
              });
            }
          }
          right.push(rightArray);

          //answer
          answers.push(question.answer?.trim().toLowerCase());
        });
      });

      const formData = new FormData();
      formData.append("from", from);

      for (let i = 0; i < questionTexts?.length; i++) {
        formData.append("questions[]", questionTexts[i]);
        formData.append("negative_mark[]", negaMarkAr[i]);
        formData.append("positive_mark[]", markAr[i]);
        formData.append("explanation[]", explanationText[i]);
        formData.append("isFormula[]", isFormulaList[i]);
        formData.append("prv_year[]", prv_year[i]);

        if (optionTexts[i]?.length > 0) {
          for (let j = 0; j < optionTexts[i]?.length; j++) {
            formData.append(`options[${i}][${j}]`, optionTexts[i][j]);
          }
        } else {
          formData.append(`options[]`, []);
        }
        if (optFormulaText[i]?.length > 0) {
          for (let j = 0; j < optFormulaText[i]?.length; j++) {
            formData.append(
              `options_formula[${i}][${j}]`,
              optFormulaText[i][j]
            );
          }
        } else {
          formData.append(`options_formula[]`, []);
        }

        if (left[i]?.length > 0) {
          for (let j = 0; j < left[i]?.length; j++) {
            formData.append(`left[${i}][]`, left[i][j]);
          }
        } else {
          formData.append(`left[]`, []);
        }

        if (right[i]?.length > 0) {
          for (let j = 0; j < right[i]?.length; j++) {
            formData.append(`right[${i}][]`, right[i][j]);
          }
        } else {
          formData.append(`right[]`, []);
        }

        formData.append("word_include[]", wordIncludeL[i]);
        formData.append("word_not_include[]", wordNotIncludeL[i]);
        formData.append("answers[]", answers[i]);
        formData.append("que_type[]", que_type[i]);
        formData.append("difficulty[]", difficulty[i]);
        formData.append("mcqid[]", qid[i]);
        formData.append("sections[]", snm ? [snm] : sections[i]);
        if (set_timer[i] === 1) {
          formData.append("timer[]", timer[i]);
        } else {
          formData.append("timer[]", "");
        }
        formData.append("set_timer[]", set_timer[i]);
        formData.append("section_mark[]", section_mark[i]);
        formData.append("section_negative_marks[]", section_negative_marks[i]);
        formData.append("optional_enable[]", optional_enable[i]);
        formData.append("optional_for[]", optional_for[i]);
        formData.append("optional_number[]", optional_number[i]);
        formData.append("optional_instruction[]", optional_instruction[i]);
        formData.append("explanation_file_val[]", expainationFileVal[i]);
        formData.append("que_file_val[]", queFileVal[i]);

        if (optFileVal[i]) {
          optFileVal[i]?.map((optf, index) => {
            formData.append(`option_file_val[${i}][]`, optf);
          });
        } else {
          formData.append(`option_file_val[${i}][]`, "");
        }
      }
      if (selectedMcqBank) {
        formData.append("mbid", selectedMcqBank);
      }

      // Append files to FormData
      explanationFileText.forEach((file, index) => {
        if (file) {
          formData.append(`explanation_file[${index}]`, file);
        }
      });
      queFileText.forEach((file, index) => {
        if (file) {
          formData.append(`que_file[${index}]`, file);
        }
      });
      optFileText.map((question, index) => {
        question.forEach((file, optionIndex) => {
          if (file) {
            formData.append(`option_file[${index}][${optionIndex}]`, file);
          }
        });
      });
      console.log({ selectedMcqBank });

      if (
        !Object.values(questions)
          .flat()
          .every((que) => que.que?.trim() !== "")
      ) {
        triggerNotification("error", "Question fields cannot be empty!!");
        return;
      } else if (
        !Object.values(questions)
          .flat()
          .every((que) => que.answer?.trim() !== "")
      ) {
        triggerNotification("error", "Answer field cannot be empty!!");
        return;
      } else if (
        !Object.values(questions)
          .flat()
          .every((que) => que.mark > 0)
      ) {
        triggerNotification("error", "Mark field cannot be empty!!");
        return;
      } else if (
        !Object.values(questions)
          .flat()
          .every((que) => que.negativeMark >= 0)
      ) {
        triggerNotification("error", "Negative mark field cannot be empty!!");
        return;
      } else if (
        !Object.values(questions)
          .flat()
          .every((que) => que.que_type?.trim() !== "")
      ) {
        triggerNotification("error", "Question Type field cannot be empty!!");
        return;
      } else if (
        !Object.values(questions)
          .flat()
          .every(
            (que) =>
              que.que_type !== "Short" ||
              (que.wordIncludeList?.length > 0 &&
                que.wordNotIncludeList?.length > 0)
          )
      ) {
        triggerNotification(
          "error",
          "Word Include and Word Not Include fields cannot be empty!!"
        );
        return;
      } else if (


        Object.values(questions)
          .flat()
          .some(
            (que) =>
              que.que_type !== "Fill In The Blanks" &&
              que.que_type !== "Short" &&
              que.que_type === "Match the pair" &&
              que.que_type === "Match the pair With Option" &&
              que.options.some((opt) => opt === "")
          )
      ) {
        triggerNotification("error", "Option fields cannot be empty!!");
        return;
      } else if (!selectedChapterOrCourseOption) {
        triggerNotification("error", "Please select course or chapter");
        return;
      } else if (!mcqid && !(selectedMcqBank + "")?.trim()) {
        triggerNotification("error", "Please select question bank");
        return;
      }
      console.log(formData.values);

      fetch(`${config.host_url}mcq`, {
        method: "POST",
        headers: {
          token: token,
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            setQuestions([]);
            if (id !== undefined && base !== undefined) {
              navigate(`/viewmcqs/${base}/${id}/${adfrom}`);
            } else if (id !== undefined) {
              navigate(`/viewmcqs/${upfrom}/${id}/${adfrom}`);
            } else {
              getQuestions(selectedMcqBank);
              // navigate("/addmcq");
            }
            triggerNotification(
              "success",
              `Questions ${mcqid ? "updated" : "added"} successfully!`
            );
          } else if (data.status === 400) {
            // Handle validation errors
            triggerNotification("error", "Validation Error.");
          } else if (data.status === 401) {
            // Handle unauthorized (invalid token)
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other server errors
            triggerNotification("error", "Internal server error.");
          }
        })
        .catch((error) => {
          // Handle fetch error here
          console.error("Fetch error:", error);
        });
    } catch (error) {
      console.error("Error creating questions:", error);
      triggerNotification(
        "error",
        `An error occurred while ${mcqid ? "updating" : "creating"
        } the questions.`
      );
    }
  };

  //--------------------------------------------------- select course and chapter functionality ---------------------------------------------------
  const handleRadioChapterWise = () => {
    setCourseWiseQue(false);
    setSelectedMcqBank("");
    setSelectedCourse("");
    setSelectedChapterOrCourseOption(""); // Clear the selected option
    setIsDropdownOpen(false);
  };

  const handleRadioCourseWise = () => {
    setCourseWiseQue(true);
    setSelectedMcqBank("");
    setSelectedChapter("");
    setSelectedChapterOrCourseOption(""); // Clear the selected option
    setIsDropdownOpen(false);
  };

  const handleSelectedChapterOrCourseOption = ({ courseId, chapterId }) => {
    console.log({ from });
    // setQueryParams()
    console.log({ from });

    setSelectedChapterOrCourseOption(courseId || chapterId);
    setSelectedMcqBank("");
    const fetchType = courseWiseQue ? "course" : "chapter";
    const idToUse = chapterId || courseId;

    //fetch mcq bank
    fetch(
      `${config.host_url}mcqbanks/${fetchType}/${idToUse}?from=${from}`,
      {
        method: "GET",
        headers: {
          token,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setMcqBanks(data.data);
      });
    setLoading(false);
  };

  const handleSelectedMcqBank = (e) => {
    setSelectedMcqBank(e.target.value);
    getQuestions(e.target.value);
    setQueFileVal([]);
    setOptFileVal([]);
    setSectionList([]);
    setExpainationFileVal([]);
  };

  //--------------------------------------------------- Fetch data for update mcq ---------------------------------------------------E
  //fetch data
  const fetchForEditMcq = async () => {
    setLoading(true);
    try {
      await fetch(
        `${config.host_url}mcq?mcqid=${mcqid}&mbid=${mbidForEdit}&from=${from}`,
        {
          method: "GET",
          headers: {
            token: token,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            const sectionListData = data.sections?.map((section, i) => ({
              section: section,
              section_mark: data.section_mark[i],
              section_negative_marks: data.section_negative_marks[i],
              set_timer: data.set_timer[i] === 1 ? true : false,
              timer: data.timer[i],
            }));
            setSectionList(sectionListData);
            const quesData = {};
            const allImages = [];
            const allQueFiles = [];
            const allOptFiles = [];
            sectionListData.forEach((sectionItem) => {
              const section = sectionItem.section;
              const sectionQuestions = data.data[section]?.map((que) => {
                let mappedQuestion = {
                  difficulty: que.difficulty,
                  isEditable: que.isEditable,
                  wordIncludeList: que.word_include?.split("@#$"),
                  wordNotIncludeList: que.word_not_include?.split("@#$"),
                  qid: que.mcqid,
                  mark: que.positive_mark,
                  negativeMark: que.negative_mark,
                  answer: que.ans,
                  explanation: que.explanation,
                  isFormula: que.isFormula === 1 ? true : false,
                  isLeftFormulaValid: true,
                  isRightFormulaValid: true,
                  explanation_file: que.explanation_file,
                  que_type: que.que_type,
                  question: que.que,
                  que_file: que.que_file,
                  sections: sectionItem,
                };

                allImages.push(mappedQuestion.explanation_file);
                allQueFiles.push(mappedQuestion.que_file);

                if (que.options?.length > 1) {
                  const result = que.options.map((opt, index) => ({
                    optTxt:
                      que.que_type === "True/False"
                        ? index === 0
                          ? "true"
                          : "false"
                        : opt,
                    option_file: que.options_file[index]
                      ? que.options_file[index]
                      : "",
                    isFormula:
                      que.options_formula[index] === "1" ? true : false,
                    isFormulaValid: true,
                  }));
                  mappedQuestion.options = result;
                  // console.log(result);
                } else {
                  const result = que.left_side.map((leftValue, index) => ({
                    left: leftValue,
                    right: que.right_side[index],
                    isFormula:
                      que.options_formula[index] === "1" ? true : false,
                    isRightFormulaValid: true,
                    isLeftFormulaValid: true,
                  }));
                  mappedQuestion.options = result;
                  allOptFiles.push(result);
                }
                return mappedQuestion;
              });
              quesData[section] = sectionQuestions;
            });
            setExpainationFileVal(allImages);
            setQueFileVal(allQueFiles);
            setOptFileVal(allOptFiles);
            const updatedQuestions = { ...quesData };
            Object.keys(updatedQuestions).forEach((key) => {
              if (updatedQuestions[key] === undefined) {
                updatedQuestions[key] = [];
              }
            });
            setQuestions(updatedQuestions);
          } else if (data.status === 401) {
            // Invalid token
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching mcq.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (mcqid !== undefined) {
      fetchForEditMcq();
    }
  }, [mcqid]);
  useEffect(() => {
    // console.log("questions: ", questions);
  }, [questions]);

  // Function to handle search input change
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  // Filter courses based on search term
  const filteredCourses = courses?.filter((course) =>
    course.course_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Handle course selection
  const handleCourseSelect = (course) => {
    setSelectedCourse(course);
    handleSelectedChapterOrCourseOption({ courseId: course.course_id, chapterId: null });
    setIsCourseDropdownOpen(false);
    setSearchTerm("");
  };


  const filteredChapters = chapters?.filter(chapter =>
    chapter.name.toLowerCase().includes(searchTerm.toLowerCase())
  );


  const handleChapterSelect = (chapter) => {
    setSelectedChapter(chapter);
    console.log("Selected chapter:", chapter);

    // Pass null for courseId and chapterId
    handleSelectedChapterOrCourseOption({ courseId: null, chapterId: chapter.chapterid });
    setIsChapterDropdownOpen(false);
    setSearchTerm("");
  };


  // Filter MCQ Banks based on search term
  const filteredMcqBanks = mcqBanks?.filter(mcqBank => {
    const bankName = from === "mcq" ? mcqBank.bank_name : mcqBank.exam_name;
    return bankName?.toLowerCase().includes(searchTerm.toLowerCase());
  });


  // Handle MCQ Bank selection
  const handleMcqBankSelect = (mcqBank) => {
    handleSelectedMcqBank(mcqBank.mbid);
    setIsDropdownOpen(false);
  };

  // Find the currently selected chapter
  //const selectedChapter = chapters.find(chapter => chapter.chapterid === selectedChapterOrCourseOption);

  const handleDeleteAllMcq = () => {
    const mcqIdsToDelete = selectAllMcq ?
      Object.values(questions).flat().map((question) => question.qid) :
      selectedMcqQuestions;

    if (mcqIdsToDelete.length === 0) {
      triggerNotification("error", "No MCQs selected for deletion.");
      return;
    }
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete All Mcqs. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleAllMcqDelete(mcqIdsToDelete);
      }
    });
  }

  const handleAllMcqDelete = async (selectedMcqQuestions) => {
    console.log("Deleting MCQs:", selectedMcqQuestions);
    try {
      const response = await fetch(`${config.host_url}mcqbanks/delete-mcq`, {
        method: "POST",
        headers: {
          token: token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ mcqid: selectedMcqQuestions }),
      });

      const data = await response.json();

      if (data.status === 200) {
        triggerNotification("success", "Deleted all MCQs successfully");

        // Update the questions state
        setQuestions((prevQuestions) => {
          const updatedQuestions = Object.fromEntries(
            Object.entries(prevQuestions).map(([section, mcqs]) => [
              section,
              mcqs.filter((mcq) => !selectedMcqQuestions.includes(mcq.qid)),
            ])
          );

          // Check if there are any remaining MCQs
          const remainingMcqsCount = Object.values(updatedQuestions).reduce(
            (count, mcqs) => count + mcqs.length,
            0
          );

          // Update the state to track if there are remaining MCQs
          setHasRemainingMcqs(remainingMcqsCount > 0);

          return updatedQuestions;
        });
      } else if (data.status === 404) {
        console.error("Chapter IDs not found");
        triggerNotification("error", "Chapter IDs not found");
      } else if (data.status === 401) {
        console.error("Invalid token");
        triggerNotification("error", "Unauthenticated User");
      } else {
        console.error("Internal server error");
        triggerNotification("error", "Internal server error, Please try after some time!");
      }
    } catch (error) {
      console.error("Error deleting MCQs:", error);
      triggerNotification("error", "Error deleting MCQs");
    }
  };


  const handleCheckboxChange = (e) => {
    console.log("kkkkkk", e);
    if (selectedMcqQuestions.indexOf(e) === -1) {
      setSelectedMcqQuestions([...selectedMcqQuestions, e]);
    } else {
      selectedMcqQuestions.splice(selectedMcqQuestions.indexOf(e), 1)
      setSelectedMcqQuestions([...selectedMcqQuestions]);
    }
    console.log(selectedMcqQuestions);


    // setSelectedMcqQuestions((prevSelected) => {
    //   // Check if the mcqid already exists in the selected questions
    //   const isAlreadySelected = prevSelected.includes(question.mcqid);

    //   if (isAlreadySelected) {
    //     // If the question is already selected, remove it from the list
    //     return prevSelected.filter((id) => id !== question.mcqid);
    //   } else {
    //     // If the question is not selected, add its mcqid to the list
    //     return [...prevSelected, question.mcqid];
    //   }
    // });
  };

  useEffect(() => {
    console.log("Selected Questions Array:", selectedMcqQuestions);
  }, [selectedMcqQuestions]);

  const handleSelectAllChange = () => {
    if (typeof questions !== "object" || questions === null) {
      console.error("questions is not an object:", questions);
      return; // Early return if questions is not an object
    }

    const allMcqIds = Object.values(questions).flat().map((question) => question.qid);

    console.log("All MCQ IDs:", allMcqIds);
    console.log("Current selected IDs:", selectedMcqQuestions);

    if (selectAllMcq) {
      setSelectedMcqQuestions([]);
    } else {
      setSelectedMcqQuestions(allMcqIds);
    }

    setSelectAllMcq(!selectAllMcq);
  };

  // Sync "Select All" checkbox based on individual selections
  useEffect(() => {
    const allMcqIds = Object.values(questions).flat().map((question) => question.qid);
    const allSelected = selectedMcqQuestions.length === allMcqIds.length;
    setSelectAllMcq(allSelected);
    console.log("Select All checkbox state:", allSelected);
  }, [selectedMcqQuestions, questions]);


  return (
    <>
      {base === "course" && !cfa ? (
        <Breadcrumb
          txt="Manage Course"
          subpath={[
            "View Courses",
            `${title} - ${decodeURIComponent(atob(adfrom))}`,
          ]}
          url={["/viewcourses"]}
        />
      ) : cfa === "yes" ? (
        <Breadcrumb
          txt="Manage Course"
          subpath={[
            "Courses For Approval",
            `${title} - ${decodeURIComponent(atob(adfrom))}`,
          ]}
          url={["/coursesforapproval"]}
        />
      ) : base === "chapter" ? (
        <Breadcrumb
          txt="Manage Chapter"
          subpath={[
            "View Chapters",
            `${title} -${decodeURIComponent(atob(adfrom))}`,
          ]}
          url={["/viewchapters"]}
        />
      ) : upfrom === "course" ? (
        <Breadcrumb
          txt="Manage Course"
          subpath={["View Courses", "View MCQs", "Update MCQ"]}
          url={["/viewcourses", `/viewmcqs/${upfrom}/${id}/${adfrom}`]}
        />
      ) : upfrom === "chapter" ? (
        <Breadcrumb
          txt="Manage Chapter"
          subpath={["View Chapters", "View MCQs", "Update MCQ"]}
          url={["/viewchapters", `/viewmcqs/${upfrom}/${id}/${adfrom}`]}
        />
      ) : (
        <Breadcrumb txt="Manage MCQ" subpath={[`${title}`]} />
      )}
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center">
            <h5 className="mb-0">
              {`${title}`} {adfrom && "- " + decodeURIComponent(atob(adfrom))}
            </h5>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="card-body">
              {!mcqid && (
                <>
                  <div className="col-md-12 mb-0">
                    {/* Question Based on */}
                    {id === undefined && (
                      <div className="col mt-2">
                        <label className="form-check-label ml-1 mr-8">
                          Question Based on :{" "}
                        </label>
                        <div className="form-check form-check-inline ml-1 ">
                          <input
                            checked={courseWiseQue ? true : false}
                            name="form-check-group-image"
                            className="form-check-input"
                            type="radio"
                            value=""
                            id="courwq"
                            onChange={handleRadioCourseWise}
                          />
                          <label className="form-check-label" htmlFor="courwq">
                            Course
                          </label>
                        </div>
                        <div className="form-check form-check-inline ml-4">
                          <input
                            checked={!courseWiseQue ? true : false}
                            name="form-check-group-image"
                            className="form-check-input"
                            type="radio"
                            value=""
                            id="chapwq"
                            onChange={handleRadioChapterWise}
                          />
                          <label className="form-check-label" htmlFor="chapwq">
                            Chapter
                          </label>
                        </div>
                        {courseWiseQue ? (
                          <div className="col-md-12 mt-2">
                            <div className="form-floating form-floating-outline mb-4">
                              <div className="form-select w-100 mx-auto" id="coursedropdown" onClick={() => {
                                setIsCourseDropdownOpen(!isCourseDropdownOpen);
                                setIsChapterDropdownOpen(false); // Close Chapter dropdown
                                setIsDropdownOpen(false); // Close MCQ Bank dropdown
                              }} style={{ padding: "8px", border: "1px solid #ced4da", borderRadius: "4px", cursor: "pointer", textAlign: selectedCourse ? "left" : "center", }}>
                                {selectedCourse ? selectedCourse.course_name : "--- Select Course ---"}
                              </div>

                              {/* Label for the dropdown, positioned at the top left */}
                              <label htmlFor="coursedropdown" className="position-absolute" style={{ top: "-1px", left: "-2px", backgroundColor: "white", padding: "0 4px", fontSize: "14px" }}>
                                Courses
                              </label>

                              {/* Custom dropdown list */}
                              {isCourseDropdownOpen && (
                                <div
                                  className="dropdown-menu show w-100"
                                  style={{ display: "block", maxHeight: "200px", overflowY: "auto" }}
                                >
                                  {/* Search Input Inside Dropdown */}
                                  <div className="p-2">
                                    <input
                                      type="text"
                                      className="form-control w-100"
                                      placeholder="Search Course"
                                      value={searchTerm}
                                      onChange={handleSearchChange}
                                    />
                                  </div>

                                  {/* Dropdown options */}
                                  <ul className="list-unstyled p-2 w-100">
                                    {filteredCourses?.map((course) => (
                                      <li
                                        key={course.course_id}
                                        className="dropdown-item w-100"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleCourseSelect(course)}
                                      >
                                        {course.course_name}
                                      </li>
                                    ))}
                                    {filteredCourses.length === 0 && (
                                      <li className="dropdown-item text-muted w-100">No courses found</li>
                                    )}
                                  </ul>
                                </div>
                              )}
                            </div>
                          </div>
                        ) : (
                          <div className="col-md-12 mt-2">
                            <div className="form-floating form-floating-outline mb-4">
                              {/* Select for Chapters */}
                              <div
                                className="form-select w-100 mx-auto"
                                id="chapterdropdown"
                                onClick={() => {
                                  setIsChapterDropdownOpen(!isChapterDropdownOpen);
                                  setIsCourseDropdownOpen(false); // Close Course dropdown
                                  setIsDropdownOpen(false); // Close MCQ Bank dropdown
                                }}
                                style={{
                                  padding: "8px",
                                  border: "1px solid #ced4da",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                  textAlign: selectedChapter ? "left" : "center", // Center if no chapter selected, left if selected
                                }}
                              >
                                {selectedChapter ? selectedChapter.name : "--- Select Chapter ---"}
                              </div>

                              {/* Label for the dropdown, positioned at the top left */}
                              <label
                                htmlFor="chapterdropdown"
                                className="position-absolute"
                                style={{
                                  top: "-1px",
                                  left: "-1px",
                                  backgroundColor: "white",
                                  padding: "0 4px",
                                  fontSize: "14px",
                                }}
                              >
                                Chapters
                              </label>

                              {/* Custom dropdown list */}
                              {isChapterDropdownOpen && (
                                <div
                                  className="dropdown-menu show w-100"
                                  style={{ display: "block", maxHeight: "200px", overflowY: "auto" }}
                                >
                                  {/* Search Input Inside Dropdown */}
                                  <div className="p-2">
                                    <input
                                      type="text"
                                      className="form-control w-100"
                                      placeholder="Search Chapter"
                                      value={searchTerm}
                                      onChange={(e) => setSearchTerm(e.target.value)} // Update search term
                                    />
                                  </div>

                                  {/* Filtered Dropdown options */}
                                  <ul className="list-unstyled p-2 w-100">
                                    {filteredChapters?.map((chapter) => (
                                      <li
                                        key={chapter.chapterid}
                                        className="dropdown-item w-100"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          handleChapterSelect(chapter);
                                          setSearchTerm("");
                                        }} // Handle chapter selection
                                      >
                                        {chapter.name}
                                      </li>
                                    ))}
                                    {filteredChapters.length === 0 && (
                                      <li className="dropdown-item text-muted w-100">No chapters found</li>
                                    )}
                                  </ul>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                    {/* Question Bank */}
                    <div className="col-md-12 mt-2">
                      <div className="form-floating form-floating-outline mb-4">
                        {/* Search Input for MCQ Bank */}
                        <div
                          className="form-select w-100 mx-auto"
                          onClick={() => {
                            setIsDropdownOpen(!isDropdownOpen);
                            setIsCourseDropdownOpen(false); // Close Course dropdown
                            setIsChapterDropdownOpen(false); // Close Chapter dropdown
                          }}
                          style={{ cursor: "pointer", textAlign: selectedMcqBank ? "left" : "center" }}
                        >
                          {selectedMcqBank ? (
                            mcqBanks.find(bank => bank.mbid === selectedMcqBank)?.bank_name || "--- Select MCQ Bank ---"
                          ) : "--- Select MCQ Bank ---"}
                        </div>
                        <label className="position-absolute" style={{ top: "-1px", left: "-1px" }}>
                          MCQ Banks
                        </label>

                        {isDropdownOpen && (
                          <div className="dropdown-menu show w-100" style={{ maxHeight: "200px", overflowY: "auto" }}>
                            <input
                              type="text"
                              className="form-control p-2"
                              placeholder="Search MCQ Banks"
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                              style={{
                                margin: '8px 20px 8px 5px',
                                width: '95%',
                              }}
                            />
                            <ul className="list-unstyled p-2 w-100">
                              {filteredMcqBanks?.map((mcqBank) => (
                                <li
                                  key={mcqBank.mbid}
                                  className="dropdown-item w-100"
                                  onClick={() => {
                                    handleSelectedMcqBank({ target: { value: mcqBank.mbid } });
                                    setIsDropdownOpen(false); // Close dropdown after selection
                                  }}
                                >
                                  {from === 'mcq' ? mcqBank.bank_name : mcqBank.exam_name}
                                </li>
                              ))}
                              {filteredMcqBanks.length === 0 && (
                                <li className="dropdown-item text-muted w-100">No MCQ Banks found</li>
                              )}
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* add excel */}
                  <div className="accordion mb-5" id="accordionTopic">
                    <div className="accordion-item">
                      <h2 className="accordion-header" id={`heading`}>
                        <div className="flex ">
                          <button
                            type="button"
                            className="accordion-button collapsed"
                            data-bs-toggle="collapse"
                            data-bs-target="#accordion"
                            aria-expanded="false"
                            aria-controls="accordion"
                          >
                            Add MCQ from an Excel File
                          </button>
                        </div>
                      </h2>
                      <div
                        id={`accordion`}
                        className="accordion-collapse collapse"
                        aria-labelledby={`heading`}
                        data-bs-parent="#accordionTopic"
                      >
                        <DropZone
                          title=" "
                          bodykey={`mbid`}
                          bodyvalue={selectedMcqBank}
                          type="mcq"
                          url={`mcq/excel`}
                          navigate={`${base !== undefined
                            ? "viewmcqs/" + base + "/" + id
                            : `addmcq`
                            }`}
                          isExamOrMcq={{ from: from }}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}

              {!mcqid && sectionList?.length < 20 && (
                // section creation
                <div className="card p-2 mb-4">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control "
                      placeholder="Enter a section "
                      value={sectionValue}
                      onChange={(e) => handleSectionValChange(e)}
                    />
                    <label htmlFor="timer"> Enter a section </label>
                  </div>
                  <div className="row mt-3 ">
                    {/* <div className="col-md-6">
                      <div className="form-floating form-floating-outline">
                        <input
                          type="number"
                          className="form-control "
                          min={1}
                          placeholder="Enter a MCQ mark "
                          value={mcqMarks || 1}
                          onChange={(e) => handleMcqMarkChange(e)}
                        />
                        <label htmlFor="mark">Enter Common MCQ mark </label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline">
                        <input
                          type="number"
                          className="form-control "
                          min={1}
                          placeholder="Enter a Negative mark "
                          value={negativeMarks || 1}
                          onChange={(e) => handleNegativeMarkChange(e)}
                        />
                        <label htmlFor="negmark">Enter Common Negative mark </label>
                      </div>
                    </div> */}

                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline">
                        <input
                          type="number"
                          className="form-control "
                          min={1}
                          placeholder="Enter a MCQ mark "
                          value={mcqMarks || 1}
                          onChange={(e) => handleMcqMarkChange(e)}
                        />
                        <label htmlFor="mark">Enter a MCQ mark </label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline">
                        <input
                          type="number"
                          className="form-control "
                          min={1}
                          placeholder="Enter a Negative mark "
                          value={negativeMarks ? negativeMarks : 1}
                          onChange={(e) => handleNegativeMarkChange(e)}
                        />
                        <label htmlFor="negmark">Enter a Negative mark </label>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3 ">
                    <div className="col-sm-3 ">
                      <div
                        className=" select-none"
                        id="examTimer"
                        name="examTimer"
                        onClick={handleTimerBtn}
                      >
                        {timer.set_timer ? (
                          <span className="mdi mdi-checkbox-marked-outline mr-3  "></span>
                        ) : (
                          <span className="mdi mdi-checkbox-blank-outline mr-3 "></span>
                        )}
                        <span>Set Timer</span>
                        <span
                          style={{
                            visibility: timer.set_timer ? "hidden" : "visible",
                          }}
                        >
                          ?
                        </span>
                      </div>
                      <div
                        className=" select-none"
                        id="enableOptinal"
                        name="enableOptinal"
                        onClick={handleOptinalBtn}
                      >
                        {enableOpt == 1 ? (
                          <span className="mdi mdi-checkbox-marked-outline mr-3  "></span>
                        ) : (
                          <span className="mdi mdi-checkbox-blank-outline mr-3 "></span>
                        )}
                        <span>Enable Optional</span>
                      </div>
                      <div className="row mt-2">
                        <div className="col-sm-6">
                          {enableOpt == 1 && (
                            <div className="form-floating form-floating-outline dropdown-with-arrow">
                              <select
                                className="form-control mb-0"
                                name="timerOptions"
                                id="timerOptions"
                                value={optSelectValue}
                                onChange={handleOptChange}
                              >
                                <option value="first">First</option>
                                <option value="any">Any</option>
                              </select>
                            </div>
                          )}

                        </div>
                        <div className="col-sm-6">
                          {
                            enableOpt == 1 && (
                              <div className="">
                                <input
                                  style={{ padding: "11px 5px" }}
                                  type="number"
                                  className="form-control"
                                  min={1}
                                  placeholder="number"
                                  value={optNumValue}
                                  onChange={(e) => setOptNumValue(e.target.value)}
                                />
                              </div>
                            )
                          }

                        </div>
                      </div>
                      {
                        enableOpt == 1 && (
                          <div className="">
                            <input
                              style={{ padding: "11px 5px", marginTop: "10px" }}
                              type="text"
                              className="form-control"
                              min={1}
                              placeholder="Enter Instruction"
                              value={instruction}
                              onChange={(e) => setInstruction(e.target.value)}
                            />
                          </div>
                        )
                      }
                    </div>
                    <div className="col-sm-9">
                      {timer.set_timer && (
                        <div className="form-floating form-floating-outline">
                          <input
                            type="number"
                            min="1"
                            className="form-control mb-0"
                            name="timer"
                            id="timer"
                            placeholder=" Exam Time (In Minutes) "
                            value={timer.timer}
                            onChange={timerValueChange}
                          />
                          <label htmlFor="timer"> Time (In Minutes) </label>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-3 mt-3 ">
                    <button
                      type="button"
                      className="btn btn-outline-primary w-full"
                      onClick={() => handleAddSectionBtn()}
                    >
                      Add
                    </button>
                  </div>
                </div>
              )}
              <div className="card p-2 mb-4">
                <h4>Common Marks</h4>
                <div className="row mt-3 ">
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="number"
                        className="form-control "
                        min={1}
                        placeholder="Enter a MCQ mark "
                        value={commonMcqMarks || 1}
                        onChange={(e) => handleCommonMcqMarkChange(e)}
                      />
                      <label htmlFor="mark">Enter Common MCQ mark </label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="number"
                        className="form-control "
                        min={1}
                        placeholder="Enter a Negative mark "
                        value={commonNegativeMcqMarks || 1}
                        onChange={(e) => handleCommonNegativeMarkChange(e)}
                      />
                      <label htmlFor="negmark">
                        Enter Common Negative mark{" "}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              {/* mcqs */}
              {sectionList?.length !== 0 ? (
                <div className="card mb-4">
                  <div className="card-header p-0 mx-1">
                    <div className="nav-align-top">
                      <div className="d-flex">
                        <ul className="nav nav-tabs mb-0" role="tablist">
                          {sectionList?.map((section, i) => (
                            <li className="nav-item" key={i}>
                              <button
                                type="button"
                                className={`nav-link ${i === 0 ? "active" : ""
                                  }`}
                                role="tab"
                                data-bs-toggle="tab"
                                data-bs-target={`#navs-top-${section.section}`}
                                aria-controls={`navs-top-${section.section}`}
                                aria-selected={i === 0 ? "true" : "false"}
                              >
                                {section.section}
                              </button>
                            </li>
                          ))}
                        </ul>
                        {
                          selectedMcqQuestions.length > 0 ?

                            <ul
                              className="float-end nav nav-tabs"
                              style={{ width: "271px" }}
                            >
                              <li className="nav-link" style={{ padding: 0 }}>
                                <button
                                  className="btn btn-sm btn-danger"
                                  onClick={handleDeleteAllMcq}
                                >
                                  <i className="fa-solid delete text-white"></i>
                                  &nbsp;&nbsp;Delete MCQ's
                                </button>
                              </li>
                            </ul> : ""
                        }
                        {
                          !mbidForEdit ?

                            <ul
                              className="float-end nav nav-tabs"
                              style={{ width: "271px" }}
                            >
                              <li className="nav-link" style={{ padding: 0 }}>
                                <a
                                  className="btn btn-sm btn-primary"
                                  href={`${config.host_url}/mcqbanks/export?mbid=${selectedMcqBank}`}
                                  target="_blank"
                                >
                                  <i className="fa-solid fa-file-export text-white"></i>
                                  &nbsp;&nbsp;Export MCQ's
                                </a>
                              </li>
                            </ul> : ""
                        }
                        {/* <div className="float-end">
                        <a href={`${config.host_url}/mcqbanks/export?mbid=${selectedMcqBank}`} target="_blank">
                        <i className="fa-solid fa-file-export"></i>
                        </a>

                        </div> */}
                      </div>
                    </div>
                  </div>

                  <div className="card-body">
                    <div className="tab-content p-0">
                      {sectionList?.map((section, i) => (
                        <div
                          key={i}
                          className={`tab-pane fade ${i === 0 && "show active"
                            } `}
                          id={`navs-top-${section.section}`}
                          role="tabpanel"
                        >
                          {/* add mcq */}
                          {hasRemainingMcqs && (
                            <>
                              <input
                                type="checkbox"
                                className="form-check-input mr-2 mb-3"
                                id="select-all-checkbox"
                                checked={selectAllMcq}
                                onChange={handleSelectAllChange}
                              />

                              <label htmlFor="select-all-checkbox">Select All MCQs</label>
                            </>
                          )
                          }
                          {questions[section.section]
                            ?.filter((question) =>
                              mbidForEdit
                                ? question.sections === section
                                : question.sections === section
                            )
                            ?.map((question, i) => {
                              let questionIndex = -1; // Initialize filteredIndex
                              questions[section.section].forEach((q, idx) => {
                                if (q === question) {
                                  questionIndex = idx;
                                }
                              });

                              return (
                                <div
                                  className="border-1 rounded p-3 shadow-0 mb-3"
                                  key={question.mcqid}
                                  hidden={
                                    mbidForEdit && !question.isEditable === true
                                  }
                                >

                                  <form>
                                    <div className="form-check d-flex align-items-center">

                                      <input
                                        type="checkbox"
                                        className="form-check-input mr-2 mb-3"
                                        name={`delete`}
                                        id={`checkbox-${i}`} // Unique ID for each checkbox
                                        checked={selectedMcqQuestions.includes(question.qid)} // Check if this question is selected
                                        onChange={(e) => handleCheckboxChange(question.qid)} // Handle checkbox toggle
                                      />
                                      {/* Question Type */}
                                      <div className="col-md-6 mt-2 mr-1 flex-grow-1">
                                        <div className=" form-floating form-floating-outline mb-4">
                                          <select
                                            className="form-select mx-auto"
                                            id="quetype"
                                            aria-label="quetype"
                                            name="que_type"
                                            value={question.que_type}
                                            onChange={(e) =>
                                              handleQuestionChange(
                                                section.section,
                                                i,
                                                "que_type",
                                                e.target.value
                                              )
                                            }
                                          >
                                            <option
                                              value=""
                                              disabled
                                              selected
                                              className="text-center"
                                            >
                                              --- Select Question Type ---
                                            </option>
                                            <option value="True/False">
                                              True/False
                                            </option>
                                            <option value="Single Choice">
                                              Single Choice
                                            </option>
                                            <option value="Multiple Choice">
                                              Multiple Choice
                                            </option>
                                            <option value="Match the pair">
                                              Match The Pair
                                            </option>
                                            <option value="Match the pair With Option">
                                              Match The Pair With Option
                                            </option>
                                            <option value="Short">
                                              Short Answer
                                            </option>
                                            <option value="Fill In The Blanks">
                                              Fill In The Blanks
                                            </option>
                                            <option value="Fill In The Blanks With Combo">
                                              Fill In The Blanks With Combo
                                            </option>
                                            <option value="Orders">Orders</option>
                                          </select>
                                          <label htmlFor="quetype">
                                            Question Type
                                          </label>
                                        </div>
                                      </div>
                                      <div className="col-md-6 mt-2 flex-grow-1">
                                        <div className=" form-floating form-floating-outline mb-4">
                                          <select
                                            className="form-select mx-auto"
                                            id="difficulty"
                                            aria-label="difficulty"
                                            name="difficulty"
                                            value={question.difficulty}
                                            onChange={(e) =>


                                              handleQuestionChange(
                                                section.section,
                                                i,
                                                "difficulty",
                                                e.target.value
                                              )
                                            }
                                          >

                                            <option value="easy">
                                              easy
                                            </option>
                                            <option value="medium">
                                              medium
                                            </option>
                                            <option value="hard">
                                              hard
                                            </option>

                                          </select>
                                          <label htmlFor="difficulty">
                                            Question Difficulty Level
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    {/* question */}
                                    <div className="flex mb-0">
                                      <div className="mb-0 border-1 border-slate-300	 rounded flex items-center mr-1">
                                        <p className="px-3 mb-0 px-auto font-bold">
                                          {i + 1}
                                        </p>
                                      </div>
                                      {question.isFormula ? (
                                        <div className="form-floating form-floating-outline  w-full border p-2 rounded">
                                          <math-field
                                            onInput={(evt) =>
                                              handleQuestionChange(
                                                section.section,
                                                i,
                                                "question",
                                                evt.target.value
                                              )
                                            }
                                            style={{ width: "inherit" }}
                                            placeholder="Enter-your-expression"
                                          >
                                            {question.question}
                                          </math-field>
                                        </div>
                                      ) : (
                                        <div className="form-floating form-floating-outline  w-full">
                                          <textarea
                                            type="text"
                                            className="form-control"
                                            style={{ height: "60px" }}
                                            name="question"
                                            placeholder="Question"
                                            value={question.question}
                                            onChange={(e) =>
                                              handleQuestionChange(
                                                section.section,
                                                i,
                                                "question",
                                                e.target.value
                                              )
                                            }
                                          />
                                          <label>Question</label>
                                        </div>
                                      )}
                                      <>
                                        <input
                                          type="file"
                                          className="form-control"
                                          name="que_file"
                                          // id={`que_file${i}`}
                                          id={`que_file_${section.section}_${i}`}
                                          style={{ display: "none" }} // Hide the file input
                                          onChange={(e) =>
                                            handleQuestionChange(
                                              section.section,
                                              i,
                                              "que_file",
                                              e
                                            )
                                          }
                                        />

                                        <button
                                          type="button"
                                          className="btn mx-2 btn-secondary w-[200px]"
                                          onClick={() =>
                                            document.getElementById(`que_file_${section.section}_${i}`).click()
                                            // document
                                            //   .getElementById(`que_file${i}`)
                                            //   .click()
                                          } // Trigger file input click
                                        >
                                          {question?.que_file !== "" &&
                                            question?.que_file !== undefined ? (
                                            <span className="flex flex-col">
                                              <span className="">
                                                Upload File
                                              </span>
                                              <span className="text-xs	font-extralight		">
                                                {question?.que_file?.name
                                                  ? question?.que_file?.name
                                                    ?.length > 15
                                                    ? question.que_file?.name.slice(
                                                      0,
                                                      13
                                                    ) + "..."
                                                    : question?.que_file?.name
                                                  : question?.que_file?.length >
                                                    15
                                                    ? question.que_file.slice(
                                                      0,
                                                      13
                                                    ) + "..."
                                                    : question?.que_file}
                                              </span>
                                            </span>
                                          ) : (
                                            "Upload File"
                                          )}
                                        </button>
                                      </>
                                    </div>
                                    {/* prompt msg */}
                                    {question.que_type ===
                                      "Fill In The Blanks" && (
                                        <>
                                          <span className="text-xs	mt-2">
                                            Please use {"{dash}"} to indicate the
                                            location where you would like to add
                                            blanks in the text
                                          </span>
                                        </>
                                      )}
                                    {question.que_type ===
                                      "Fill In The Blanks With Combo" && (
                                        <>
                                          <span className="text-xs mt-2">
                                            Please use {"{dash}"} to indicate the
                                            location where you would like to add
                                            blanks in the text
                                          </span>
                                        </>
                                      )}

                                    {/* isFormula */}
                                    <div className="flex  mt-1">
                                      <div className="col-sm-2 ml-11">
                                        <div
                                          className="select-none"
                                          id="isFormula"
                                          name="isFormula"
                                          onClick={(e) =>
                                            handleQuestionChange(
                                              section.section,
                                              i,
                                              "isFormula",
                                              e.target.value
                                            )
                                          }
                                        >
                                          {question.isFormula ? (
                                            <span className="mdi mdi-checkbox-marked-outline mr-3  "></span>
                                          ) : (
                                            <span className="mdi mdi-checkbox-blank-outline mr-3 "></span>
                                          )}
                                          <span>Math Formula</span>
                                        </div>
                                      </div>
                                      <div className="col-lg-7 flex">
                                        {question.isFormula &&
                                          !question.isFormulaValid && (
                                            <div className="col-sm-3 ml-11 text-red-400">
                                              {"*Invalid Formula"}
                                            </div>
                                          )}
                                      </div>
                                    </div>

                                    {/* explanation */}
                                    {question.que_type && (
                                      <div className="flex mb-0  mt-4">
                                        <div className="form-floating form-floating-outline  w-full">
                                          <textarea
                                            type="text"
                                            className="form-control"
                                            style={{ height: "60px" }}
                                            name="explanation"
                                            placeholder="Explanation"
                                            value={question.explanation}
                                            onChange={(e) =>
                                              handleQuestionChange(
                                                section.section,
                                                i,
                                                "explanation",
                                                e.target.value
                                              )
                                            }
                                          />
                                          <label>Explanation</label>
                                        </div>
                                      </div>
                                    )}

                                    {/* explanation_file */}
                                    {question.que_type && (
                                      <div className="flex mb-0  mt-4">
                                        <div className="form-floating form-floating-outline  w-full">
                                          <input
                                            type="file"
                                            className="form-control"
                                            name="explanation_file"
                                            id="explanation_file"
                                            onChange={(e) =>
                                              handleQuestionChange(
                                                section.section,
                                                i,
                                                "explanation_file",
                                                e
                                              )
                                            }
                                          />
                                          <label htmlFor="explanation_file">
                                            Explanation File
                                          </label>
                                        </div>
                                      </div>
                                    )}
                                    {question.explanation_file !== "undefined" && question.explanation_file && (
                                      <a className="mx-3" href={question.explanation_file} target="_blank" rel="noopener noreferrer"><b>Explanation File</b></a>
                                    )}
                                    {/* mark | negative mark  */}
                                    {question.que_type && (
                                      <div className="row mt-4 mb-4">
                                        {/* mark */}
                                        <div className="col-md-6">
                                          <div className="flex mb-0  ">
                                            <div className="form-floating form-floating-outline  w-full">
                                              <input
                                                type="number"
                                                className="form-control"
                                                name="mark"
                                                placeholder="Mark"
                                                value={question.mark || 1}
                                                onChange={(e) =>
                                                  handleQuestionChange(
                                                    section.section,
                                                    i,
                                                    "mark",
                                                    e.target.value
                                                  )
                                                }
                                              />
                                              <label>Mark</label>
                                            </div>
                                          </div>
                                        </div>

                                        {/* negative mark */}
                                        <div className="col-md-6">
                                          <div className="flex mb-0  ">
                                            <div className="form-floating form-floating-outline  w-full">
                                              <input
                                                type="number"
                                                className="form-control"
                                                name="negativeMark"
                                                placeholder="Negative Mark"
                                                value={
                                                  question.negativeMark !== undefined ? question.negativeMark : 1

                                                }
                                                onChange={(e) =>
                                                  handleQuestionChange(
                                                    section.section,
                                                    i,
                                                    "negativeMark",
                                                    e.target.value
                                                  )
                                                }
                                              />
                                              <label>Negative Mark</label>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}

                                    {/* options */}
                                    {question.que_type === "Single Choice" ||
                                      question.que_type === "Orders" ? (
                                      //single choice options || order
                                      question.options?.map(
                                        (option, optionIndex) => (
                                          <div key={optionIndex}>
                                            <div className="input-group ">
                                              {question.que_type !==
                                                "Orders" && (
                                                  <div className="input-group-text form-check mb-0">
                                                    <input
                                                      type="radio"
                                                      name="radioBtn"
                                                      className="form-check-input m-auto"
                                                      checked={
                                                        option.optTxt !== "" &&
                                                        option.optTxt ===
                                                        question.answer
                                                      }
                                                      onChange={(e) =>
                                                        handleOptionChange(
                                                          e,
                                                          section.section,
                                                          i,
                                                          optionIndex
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                )}
                                              {option.isFormula ? (
                                                <div className="form-floating form-floating-outline  border rounded-r-lg">
                                                  <math-field
                                                    name="optTxt"
                                                    onInput={(e) =>
                                                      handleOptionChange(
                                                        e,
                                                        section.section,
                                                        i,
                                                        optionIndex
                                                      )
                                                    }
                                                    style={{
                                                      width:
                                                        "-webkit-fill-available",
                                                    }}
                                                    placeholder="Enter-your-expression"
                                                  >
                                                    {option.optTxt}
                                                  </math-field>
                                                </div>
                                              ) : (
                                                <input
                                                  type="text"
                                                  name="optTxt"
                                                  className="form-control"
                                                  aria-label="Text input with radio button"
                                                  value={option.optTxt}
                                                  onChange={(e) =>
                                                    handleOptionChange(
                                                      e,
                                                      section.section,
                                                      i,
                                                      optionIndex
                                                    )
                                                  }
                                                />
                                              )}
                                              {/* remove option */}
                                              {optionIndex !== undefined &&
                                                optionIndex > 1 && (
                                                  <button
                                                    type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={() =>
                                                      handleRemoveOptionBtn(
                                                        section.section,
                                                        questionIndex,
                                                        optionIndex
                                                      )
                                                    }
                                                  >
                                                    Remove
                                                  </button>
                                                )}

                                              <>
                                                <input
                                                  type="file"
                                                  className="form-control"
                                                  name="option_file"
                                                  // id={`option_file${questionIndex}${optionIndex}`}
                                                  id={`option_file_${section.section}_${questionIndex}_${optionIndex}`}
                                                  style={{ display: "none" }} // Hide the file input
                                                  onChange={(e) =>
                                                    handleOptionChange(
                                                      e,
                                                      section.section,
                                                      i,
                                                      optionIndex
                                                    )
                                                  }
                                                />

                                                <button
                                                  type="button"
                                                  className="btn mx-2 btn-secondary w-[200px]"
                                                  onClick={() =>
                                                    // document
                                                    //   .getElementById(
                                                    //     `option_file${questionIndex}${optionIndex}`
                                                    //   )
                                                    //   .click()
                                                    document
                                                      .getElementById(
                                                        `option_file_${section.section}_${questionIndex}_${optionIndex}`
                                                      )
                                                      .click()
                                                  } // Trigger file input click
                                                >
                                                  {option?.option_file !== "" &&
                                                    option?.option_file !==
                                                    undefined ? (
                                                    <span className="flex flex-col">
                                                      <span className="">
                                                        Upload File
                                                      </span>
                                                      <span className="text-xs	font-extralight		">
                                                        {option?.option_file
                                                          ?.name
                                                          ? option?.option_file
                                                            ?.name?.length >
                                                            21
                                                            ? option.option_file?.name.slice(
                                                              0,
                                                              19
                                                            ) + "..."
                                                            : option
                                                              ?.option_file
                                                              ?.name
                                                          : option?.option_file
                                                            .length > 21
                                                            ? option.option_file.slice(
                                                              0,
                                                              19
                                                            ) + "..."
                                                            : option?.option_file}
                                                      </span>
                                                    </span>
                                                  ) : (
                                                    "Upload File"
                                                  )}
                                                </button>
                                              </>
                                            </div>
                                            <div className="flex">
                                              <div
                                                className="select-none ml-11 col-sm-2 mt-1 mb-3"
                                                id="isFormula"
                                                name="isFormula"
                                                onClick={(e) =>
                                                  handleOptionChange(
                                                    e,
                                                    section.section,
                                                    i,
                                                    optionIndex
                                                  )
                                                }
                                              >
                                                {option.isFormula ? (
                                                  <span className="mdi mdi-checkbox-marked-outline mr-3  "></span>
                                                ) : (
                                                  <span className="mdi mdi-checkbox-blank-outline mr-3 "></span>
                                                )}
                                                <span>Math Formula</span>
                                              </div>
                                              {option?.isFormula &&
                                                !option.isFormulaValid && (
                                                  <div className="col-sm-2 ml-11 mt-1 text-red-400">
                                                    {"*Invalid Formula"}
                                                  </div>
                                                )}
                                            </div>
                                          </div>
                                        )
                                      )
                                    ) : question.que_type ===
                                      "Multiple Choice" ? (
                                      //multiple choice options
                                      question.options?.map(
                                        (option, optionIndex) => (
                                          <div key={optionIndex}>
                                            <div className="input-group ">
                                              {question.que_type !==
                                                "Orders" && (
                                                  <div className="input-group-text form-check mb-0">
                                                    <input
                                                      type="checkbox"
                                                      name="checkboxBtn"
                                                      className="form-check-input m-auto"
                                                      checked={
                                                        option.optTxt !== "" &&
                                                        question.multipleChoice?.indexOf(
                                                          option.optTxt
                                                        ) !== -1
                                                      }
                                                      onChange={(e) =>
                                                        handleOptionChange(
                                                          e,
                                                          section.section,
                                                          i,
                                                          optionIndex
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                )}
                                              {option.isFormula ? (
                                                <div className="form-floating form-floating-outline  border rounded-r-lg">
                                                  <math-field
                                                    name="optTxt"
                                                    onInput={(e) =>
                                                      handleOptionChange(
                                                        e,
                                                        section.section,
                                                        i,
                                                        optionIndex
                                                      )
                                                    }
                                                    style={{
                                                      width:
                                                        "-webkit-fill-available",
                                                    }}
                                                    placeholder="Enter-your-expression"
                                                  >
                                                    {option.optTxt}
                                                  </math-field>
                                                </div>
                                              ) : (
                                                <input
                                                  type="text"
                                                  name="optTxt"
                                                  className="form-control"
                                                  aria-label="Text input with radio button"
                                                  value={option.optTxt}
                                                  onChange={(e) =>
                                                    handleOptionChange(
                                                      e,
                                                      section.section,
                                                      i,
                                                      optionIndex
                                                    )
                                                  }
                                                />
                                              )}
                                              {/* remove option */}
                                              {optionIndex !== undefined &&
                                                optionIndex > 1 && (
                                                  <button
                                                    type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={() =>
                                                      handleRemoveOptionBtn(
                                                        section.section,
                                                        questionIndex,
                                                        optionIndex
                                                      )
                                                    }
                                                  >
                                                    Remove
                                                  </button>
                                                )}

                                              <>
                                                <input
                                                  type="file"
                                                  className="form-control"
                                                  name="option_file"
                                                  id={`option_file${questionIndex}${optionIndex}`}
                                                  style={{ display: "none" }} // Hide the file input
                                                  onChange={(e) =>
                                                    handleOptionChange(
                                                      e,
                                                      section.section,
                                                      i,
                                                      optionIndex
                                                    )
                                                  }
                                                />

                                                <button
                                                  type="button"
                                                  className="btn mx-2 btn-secondary w-[200px]"
                                                  onClick={() =>
                                                    document
                                                      .getElementById(
                                                        `option_file${questionIndex}${optionIndex}`
                                                      )
                                                      .click()
                                                  } // Trigger file input click
                                                >
                                                  {option?.option_file !== "" &&
                                                    option?.option_file !==
                                                    undefined ? (
                                                    <span className="flex flex-col">
                                                      <span className="">
                                                        Upload File
                                                      </span>
                                                      <span className="text-xs	font-extralight		">
                                                        {option?.option_file
                                                          ?.name
                                                          ? option?.option_file
                                                            ?.name?.length >
                                                            21
                                                            ? option.option_file?.name.slice(
                                                              0,
                                                              19
                                                            ) + "..."
                                                            : option
                                                              ?.option_file
                                                              ?.name
                                                          : option?.option_file
                                                            .length > 21
                                                            ? option.option_file.slice(
                                                              0,
                                                              19
                                                            ) + "..."
                                                            : option?.option_file}
                                                      </span>
                                                    </span>
                                                  ) : (
                                                    "Upload File"
                                                  )}
                                                </button>
                                              </>
                                            </div>
                                            <div className="flex">
                                              <div
                                                className="select-none ml-11 col-sm-2 mt-1 mb-3"
                                                id="isFormula"
                                                name="isFormula"
                                                onClick={(e) =>
                                                  handleOptionChange(
                                                    e,
                                                    section.section,
                                                    i,
                                                    optionIndex
                                                  )
                                                }
                                              >
                                                {option.isFormula ? (
                                                  <span className="mdi mdi-checkbox-marked-outline mr-3  "></span>
                                                ) : (
                                                  <span className="mdi mdi-checkbox-blank-outline mr-3 "></span>
                                                )}
                                                <span>Math Formula</span>
                                              </div>
                                              {option?.isFormula &&
                                                !option.isFormulaValid && (
                                                  <div className="col-sm-2 ml-11 mt-1 text-red-400">
                                                    {"*Invalid Formula"}
                                                  </div>
                                                )}
                                            </div>
                                          </div>
                                        )
                                      )
                                    ) : question.que_type === "True/False" ? (
                                      <>
                                        <div className="input-group mt-4">
                                          <div className="input-group-text form-check mb-0">
                                            <input
                                              type="radio"
                                              name="true_false"
                                              checked={
                                                question.answer === "true"
                                              }
                                              className="form-check-input m-auto"
                                              onChange={(e) =>
                                                handleOptionChange(
                                                  e,
                                                  section.section,
                                                  i,
                                                  0
                                                )
                                              }
                                            />
                                          </div>
                                          <input
                                            type="text"
                                            className="form-control"
                                            aria-label="Text input with radio button"
                                            value="true"
                                          />
                                        </div>
                                        <div className="input-group mt-4">
                                          <div className="input-group-text form-check mb-0">
                                            <input
                                              type="radio"
                                              name="true_false"
                                              checked={
                                                question.answer === "false"
                                              }
                                              className="form-check-input m-auto"
                                              onChange={(e) =>
                                                handleOptionChange(
                                                  e,
                                                  section.section,
                                                  i,
                                                  1
                                                )
                                              }
                                            />
                                          </div>
                                          <input
                                            type="text"
                                            className="form-control"
                                            aria-label="Text input with radio button"
                                            value="false"
                                          />
                                        </div>
                                      </>
                                    ) : question.que_type ===
                                      "Match the pair" ? (
                                      question.match?.map(
                                        (option, optionIndex) => (
                                          <div key={optionIndex}>
                                            <div className="input-group mt-4">
                                              {/* left */}
                                              {option.isFormula ? (
                                                <div className="form-floating form-floating-outline  border rounded-r-lg">
                                                  <math-field
                                                    name="left"
                                                    onInput={(e) =>
                                                      handleOptionChange(
                                                        e,
                                                        section.section,
                                                        i,
                                                        optionIndex
                                                      )
                                                    }
                                                    style={{
                                                      width:
                                                        "-webkit-fill-available",
                                                    }}
                                                    placeholder="Enter-your-expression"
                                                  >
                                                    {option.left}
                                                  </math-field>
                                                </div>
                                              ) : (
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  aria-label="Text input with radio button"
                                                  name="left"
                                                  placeholder="left value"
                                                  value={option.left}
                                                  onChange={(e) =>
                                                    handleOptionChange(
                                                      e,
                                                      section.section,
                                                      i,
                                                      optionIndex
                                                    )
                                                  }
                                                />
                                              )}

                                              {/* right */}
                                              {option.isFormula ? (
                                                <div className="form-floating form-floating-outline  border rounded-r-lg">
                                                  <math-field
                                                    name="right"
                                                    onInput={(e) =>
                                                      handleOptionChange(
                                                        e,
                                                        section.section,
                                                        i,
                                                        optionIndex
                                                      )
                                                    }
                                                    style={{
                                                      width:
                                                        "-webkit-fill-available",
                                                    }}
                                                    placeholder="Enter-your-expression"
                                                  >
                                                    {option.right}
                                                  </math-field>
                                                </div>
                                              ) : (
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  aria-label="Text input with radio button"
                                                  name="right"
                                                  placeholder="right value"
                                                  value={option.right}
                                                  onChange={(e) =>
                                                    handleOptionChange(
                                                      e,
                                                      section.section,
                                                      i,
                                                      optionIndex
                                                    )
                                                  }
                                                />
                                              )}

                                              {/* remove option */}
                                              {optionIndex !== undefined &&
                                                optionIndex > 1 && (
                                                  <button
                                                    type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={() =>
                                                      handleRemoveOptionBtn(
                                                        section.section,
                                                        questionIndex,
                                                        optionIndex
                                                      )
                                                    }
                                                  >
                                                    Remove
                                                  </button>
                                                )}
                                            </div>
                                            {/* formula */}
                                            <div className="flex">
                                              {" "}
                                              <div className="col-sm-2 mt-1 ">
                                                <div
                                                  className="select-none"
                                                  id="isFormula"
                                                  name="isFormula"
                                                  onClick={(e) =>
                                                    handleOptionChange(
                                                      e,
                                                      section.section,
                                                      i,
                                                      optionIndex
                                                    )
                                                  }
                                                >
                                                  {option.isFormula ? (
                                                    <span className="mdi mdi-checkbox-marked-outline mr-3  "></span>
                                                  ) : (
                                                    <span className="mdi mdi-checkbox-blank-outline mr-3 "></span>
                                                  )}
                                                  <span>Math Formula</span>
                                                </div>
                                              </div>
                                              <div className="col-sm-4 ">
                                                {option?.isFormula &&
                                                  !option.isLeftFormulaValid && (
                                                    <div className="text-end	mt-1 text-red-400">
                                                      {"*Invalid Formula"}
                                                    </div>
                                                  )}
                                              </div>
                                              <div className="col-sm-6">
                                                {option?.isFormula &&
                                                  !option.isRightFormulaValid && (
                                                    <div className=" text-end	  mt-1 text-red-400">
                                                      {"*Invalid Formula"}
                                                    </div>
                                                  )}
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      )
                                    ) : question.que_type ===
                                      "Match the pair With Option" ? (
                                      question.match?.map(
                                        (option, optionIndex) => (
                                          <div key={optionIndex}>
                                            <div className="input-group mt-4">
                                              {/* left */}
                                              {option.isFormula ? (
                                                <div className="form-floating form-floating-outline  border rounded-r-lg">
                                                  <math-field
                                                    name="left"
                                                    onInput={(e) =>
                                                      handleOptionChange(
                                                        e,
                                                        section.section,
                                                        i,
                                                        optionIndex
                                                      )
                                                    }
                                                    style={{
                                                      width:
                                                        "-webkit-fill-available",
                                                    }}
                                                    placeholder="Enter-your-expression"
                                                  >
                                                    {option.left}
                                                  </math-field>
                                                </div>
                                              ) : (
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  aria-label="Text input with radio button"
                                                  name="left"
                                                  placeholder="left value"
                                                  value={option.left}
                                                  onChange={(e) =>
                                                    handleOptionChange(
                                                      e,
                                                      section.section,
                                                      i,
                                                      optionIndex
                                                    )
                                                  }
                                                />
                                              )}

                                              {/* right */}
                                              {option.isFormula ? (
                                                <div className="form-floating form-floating-outline  border rounded-r-lg">
                                                  <math-field
                                                    name="right"
                                                    onInput={(e) =>
                                                      handleOptionChange(
                                                        e,
                                                        section.section,
                                                        i,
                                                        optionIndex
                                                      )
                                                    }
                                                    style={{
                                                      width:
                                                        "-webkit-fill-available",
                                                    }}
                                                    placeholder="Enter-your-expression"
                                                  >
                                                    {option.right}
                                                  </math-field>
                                                </div>
                                              ) : (
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  aria-label="Text input with radio button"
                                                  name="right"
                                                  placeholder="right value"
                                                  value={option.right}
                                                  onChange={(e) =>
                                                    handleOptionChange(
                                                      e,
                                                      section.section,
                                                      i,
                                                      optionIndex
                                                    )
                                                  }
                                                />
                                              )}

                                              {/* remove option */}
                                              {optionIndex !== undefined &&
                                                optionIndex > 1 && (
                                                  <button
                                                    type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={() =>
                                                      handleRemoveOptionBtn(
                                                        section.section,
                                                        questionIndex,
                                                        optionIndex
                                                      )
                                                    }
                                                  >
                                                    Remove
                                                  </button>
                                                )}
                                            </div>
                                            {/* formula */}
                                            <div className="flex">
                                              {" "}
                                              <div className="col-sm-2 mt-1 ">
                                                <div
                                                  className="select-none"
                                                  id="isFormula"
                                                  name="isFormula"
                                                  onClick={(e) =>
                                                    handleOptionChange(
                                                      e,
                                                      section.section,
                                                      i,
                                                      optionIndex
                                                    )
                                                  }
                                                >
                                                  {option.isFormula ? (
                                                    <span className="mdi mdi-checkbox-marked-outline mr-3  "></span>
                                                  ) : (
                                                    <span className="mdi mdi-checkbox-blank-outline mr-3 "></span>
                                                  )}
                                                  <span>Math Formula</span>
                                                </div>
                                              </div>
                                              <div className="col-sm-4 ">
                                                {option?.isFormula &&
                                                  !option.isLeftFormulaValid && (
                                                    <div className="text-end	mt-1 text-red-400">
                                                      {"*Invalid Formula"}
                                                    </div>
                                                  )}
                                              </div>
                                              <div className="col-sm-6">
                                                {option?.isFormula &&
                                                  !option.isRightFormulaValid && (
                                                    <div className=" text-end	  mt-1 text-red-400">
                                                      {"*Invalid Formula"}
                                                    </div>
                                                  )}
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      )
                                    ) : question.que_type === "Short" ? (
                                      <div className="">
                                        <div className="mt-4">
                                          <Tags
                                            value={question.wordIncludeList}
                                            placeholder="Enter words that must be included in the answer"
                                            onChange={(e) =>
                                              handleQuestionChange(
                                                section.section,
                                                i,
                                                "wordIncludeList",
                                                e
                                              )
                                            }
                                          />
                                        </div>
                                        <div className="mt-4">
                                          <Tags
                                            value={question.wordNotIncludeList}
                                            placeholder={
                                              question.wordNotIncludeList
                                                ?.length > 2
                                                ? `Enter words that must not be included in the answer`
                                                : "Enter words that must not be included in the answer"
                                            }
                                            onChange={(e) =>
                                              handleQuestionChange(
                                                section.section,
                                                i,
                                                "wordNotIncludeList",
                                                e
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    ) : (
                                      <></>
                                    )}
                                    {question.que_type ===
                                      "Match the pair With Option"
                                      ? question.options?.map(
                                        (option, optionIndex) => (
                                          <div
                                            key={optionIndex}
                                            className="mt-2"
                                          >
                                            <div className="input-group ">
                                              {question.que_type !==
                                                "Orders" && (
                                                  <div className="input-group-text form-check mb-0">
                                                    <input
                                                      type="radio"
                                                      name="radioBtn"
                                                      className="form-check-input m-auto"
                                                      checked={
                                                        option.optTxt !== "" &&
                                                        option.optTxt ===
                                                        question.answer
                                                      }
                                                      onChange={(e) =>
                                                        handleOptionChange(
                                                          e,
                                                          section.section,
                                                          i,
                                                          optionIndex
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                )}
                                              {option.isFormula ? (
                                                <div className="form-floating form-floating-outline  border rounded-r-lg">
                                                  <math-field
                                                    name="optTxt"
                                                    onInput={(e) =>
                                                      handleOptionChange(
                                                        e,
                                                        section.section,
                                                        i,
                                                        optionIndex
                                                      )
                                                    }
                                                    style={{
                                                      width:
                                                        "-webkit-fill-available",
                                                    }}
                                                    placeholder="Enter-your-expression"
                                                  >
                                                    {option.optTxt}
                                                  </math-field>
                                                </div>
                                              ) : (
                                                <input
                                                  type="text"
                                                  name="optTxt"
                                                  className="form-control"
                                                  aria-label="Text input with radio button"
                                                  value={option.optTxt}
                                                  onChange={(e) =>
                                                    handleOptionChange(
                                                      e,
                                                      section.section,
                                                      i,
                                                      optionIndex
                                                    )
                                                  }
                                                />
                                              )}
                                              {/* remove option */}
                                              {optionIndex !== undefined &&
                                                optionIndex > 1 && (
                                                  <button
                                                    type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={() =>
                                                      handleRemoveOptionBtn(
                                                        section.section,
                                                        questionIndex,
                                                        optionIndex
                                                      )
                                                    }
                                                  >
                                                    Remove
                                                  </button>
                                                )}

                                              <>
                                                <input
                                                  type="file"
                                                  className="form-control"
                                                  name="option_file"
                                                  id={`option_file${questionIndex}${optionIndex}`}
                                                  style={{ display: "none" }} // Hide the file input
                                                  onChange={(e) =>
                                                    handleOptionChange(
                                                      e,
                                                      section.section,
                                                      i,
                                                      optionIndex
                                                    )
                                                  }
                                                />

                                                <button
                                                  type="button"
                                                  className="btn mx-2 btn-secondary w-[200px]"
                                                  onClick={() =>
                                                    document
                                                      .getElementById(
                                                        `option_file${questionIndex}${optionIndex}`
                                                      )
                                                      .click()
                                                  } // Trigger file input click
                                                >
                                                  {option?.option_file !==
                                                    "" &&
                                                    option?.option_file !==
                                                    undefined ? (
                                                    <span className="flex flex-col">
                                                      <span className="">
                                                        Upload File
                                                      </span>
                                                      <span className="text-xs	font-extralight		">
                                                        {option?.option_file
                                                          ?.name
                                                          ? option
                                                            ?.option_file
                                                            ?.name?.length >
                                                            21
                                                            ? option.option_file?.name.slice(
                                                              0,
                                                              19
                                                            ) + "..."
                                                            : option
                                                              ?.option_file
                                                              ?.name
                                                          : option
                                                            ?.option_file
                                                            .length > 21
                                                            ? option.option_file.slice(
                                                              0,
                                                              19
                                                            ) + "..."
                                                            : option?.option_file}
                                                      </span>
                                                    </span>
                                                  ) : (
                                                    "Upload File"
                                                  )}
                                                </button>
                                              </>
                                            </div>
                                            <div className="flex">
                                              <div
                                                className="select-none ml-11 col-sm-2 mt-1 mb-3"
                                                id="isFormula"
                                                name="isFormula"
                                                onClick={(e) =>
                                                  handleOptionChange(
                                                    e,
                                                    section.section,
                                                    i,
                                                    optionIndex
                                                  )
                                                }
                                              >
                                                {option.isFormula ? (
                                                  <span className="mdi mdi-checkbox-marked-outline mr-3  "></span>
                                                ) : (
                                                  <span className="mdi mdi-checkbox-blank-outline mr-3 "></span>
                                                )}
                                                <span>Math Formula</span>
                                              </div>
                                              {option?.isFormula &&
                                                !option.isFormulaValid && (
                                                  <div className="col-sm-2 ml-11 mt-1 text-red-400">
                                                    {"*Invalid Formula"}
                                                  </div>
                                                )}
                                            </div>
                                          </div>
                                        )
                                      )
                                      : question.que_type ===
                                        "Fill In The Blanks With Combo"
                                        ? //Fill In The Blanks With Combo
                                        question.options?.map(
                                          (option, optionIndex) => (
                                            <div key={optionIndex}>
                                              <div className="input-group ">
                                                {question.que_type !== "Orders"}
                                                {option.isFormula ? (
                                                  <div className="form-floating form-floating-outline  border rounded-r-lg">
                                                    <math-field
                                                      name="optTxt"
                                                      onInput={(e) =>
                                                        handleOptionChange(
                                                          e,
                                                          section.section,
                                                          i,
                                                          optionIndex
                                                        )
                                                      }
                                                      style={{
                                                        width:
                                                          "-webkit-fill-available",
                                                      }}
                                                      placeholder="Enter-your-expression"
                                                    >
                                                      {option.optTxt}
                                                    </math-field>
                                                  </div>
                                                ) : (
                                                  <input
                                                    type="text"
                                                    name="optTxt"
                                                    className="form-control"
                                                    aria-label="Text input with radio button"
                                                    value={option.optTxt}
                                                    onChange={(e) =>
                                                      handleOptionChange(
                                                        e,
                                                        section.section,
                                                        i,
                                                        optionIndex
                                                      )
                                                    }
                                                  />
                                                )}
                                                {/* remove option */}
                                                {optionIndex !== undefined &&
                                                  optionIndex > 1 && (
                                                    <button
                                                      type="button"
                                                      className="btn btn-outline-danger"
                                                      onClick={() =>
                                                        handleRemoveOptionBtn(
                                                          section.section,
                                                          questionIndex,
                                                          optionIndex
                                                        )
                                                      }
                                                    >
                                                      Remove
                                                    </button>
                                                  )}

                                                <>
                                                  <input
                                                    type="file"
                                                    className="form-control"
                                                    name="option_file"
                                                    id={`option_file${questionIndex}${optionIndex}`}
                                                    style={{ display: "none" }} // Hide the file input
                                                    onChange={(e) =>
                                                      handleOptionChange(
                                                        e,
                                                        section.section,
                                                        i,
                                                        optionIndex
                                                      )
                                                    }
                                                  />

                                                  <button
                                                    type="button"
                                                    className="btn mx-2 btn-secondary w-[200px]"
                                                    onClick={() =>
                                                      document
                                                        .getElementById(
                                                          `option_file${questionIndex}${optionIndex}`
                                                        )
                                                        .click()
                                                    } // Trigger file input click
                                                  >
                                                    {option?.option_file !==
                                                      "" &&
                                                      option?.option_file !==
                                                      undefined ? (
                                                      <span className="flex flex-col">
                                                        <span className="">
                                                          Upload File
                                                        </span>
                                                        <span className="text-xs	font-extralight		">
                                                          {option?.option_file
                                                            ?.name
                                                            ? option
                                                              ?.option_file
                                                              ?.name?.length >
                                                              21
                                                              ? option.option_file?.name.slice(
                                                                0,
                                                                19
                                                              ) + "..."
                                                              : option
                                                                ?.option_file
                                                                ?.name
                                                            : option
                                                              ?.option_file
                                                              .length > 21
                                                              ? option.option_file.slice(
                                                                0,
                                                                19
                                                              ) + "..."
                                                              : option?.option_file}
                                                        </span>
                                                      </span>
                                                    ) : (
                                                      "Upload File"
                                                    )}
                                                  </button>
                                                </>
                                              </div>
                                              <div className="flex">
                                                <div
                                                  className="select-none ml-11 col-sm-2 mt-1 mb-3"
                                                  id="isFormula"
                                                  name="isFormula"
                                                  onClick={(e) =>
                                                    handleOptionChange(
                                                      e,
                                                      section.section,
                                                      i,
                                                      optionIndex
                                                    )
                                                  }
                                                >
                                                  {option.isFormula ? (
                                                    <span className="mdi mdi-checkbox-marked-outline mr-3  "></span>
                                                  ) : (
                                                    <span className="mdi mdi-checkbox-blank-outline mr-3 "></span>
                                                  )}
                                                  <span>Math Formula</span>
                                                </div>
                                                {option?.isFormula &&
                                                  !option.isFormulaValid && (
                                                    <div className="col-sm-2 ml-11 mt-1 text-red-400">
                                                      {"*Invalid Formula"}
                                                    </div>
                                                  )}
                                              </div>
                                            </div>
                                          )
                                        )
                                        : ""}

                                    {question.que_type ===
                                      "Fill In The Blanks With Combo" && (
                                        <>
                                          {/* Find the number of {dash} occurrences */}
                                          <div className="flex flex-wrap mt-1 mb-3">
                                            {Array.from({
                                              length: (
                                                question.question.match(
                                                  /{dash}/g
                                                ) || []
                                              ).length,
                                            }).map((_, index) => (
                                              <div
                                                key={index}
                                                className="mr-2 mb-2"
                                              >
                                                <label className="text-sm mb-2">
                                                  Answer {index + 1}
                                                </label>
                                                <select
                                                  className="form-control"
                                                  name="drop-down"
                                                  // value={index}
                                                  value={
                                                    question.multipleChoice &&
                                                      question.multipleChoice[index]
                                                      ? question.multipleChoice[
                                                      index
                                                      ]
                                                      : ""
                                                  }
                                                  onChange={(e) => {
                                                    console.log(
                                                      `Dropdown Index: ${index}, New Value: ${e.target.value}`
                                                    );
                                                    handleOptionChange(
                                                      e,
                                                      section.section,
                                                      i,
                                                      index
                                                    ); // Update the selected option for each dropdown
                                                  }}
                                                >
                                                  <option value="">
                                                    Select an option
                                                  </option>
                                                  {/* Populate each dropdown with all optTxt values */}
                                                  {question.options?.map(
                                                    (option, optionIndex) => (
                                                      <option
                                                        key={optionIndex}
                                                        value={option.optTxt}
                                                      >
                                                        {option.optTxt}
                                                      </option>
                                                    )
                                                  )}
                                                </select>
                                              </div>
                                            ))}
                                          </div>
                                        </>
                                      )}

                                    {/* answer */}
                                    <div
                                      className="mb-4 "
                                      hidden={
                                        question.que_type === "Match the pair"
                                      }
                                    >
                                      <div className="form-floating form-floating-outline mt-4">
                                        {(question.que_type === "Orders" ||
                                          question.que_type ===
                                          "Single Choice") && (
                                            <h5 className="select-none border border-black opacity-100	bg-[#F4F4F6] p-1	 rounded">
                                              <MathFormulaViewer
                                                boxSize={screenInWidth}
                                                value={question.answer}
                                              ></MathFormulaViewer>
                                            </h5>
                                          )}
                                        <input
                                          type="text"
                                          hidden={
                                            question.que_type === "Orders" ||
                                            question.que_type ===
                                            "Single Choice"
                                          }
                                          className="form-control"
                                          disabled={
                                            !(
                                              question.que_type ===
                                              "Fill In The Blanks" ||
                                              question.que_type === "Short"
                                            )
                                          }
                                          name="answer"
                                          placeholder="Answer"
                                          value={question.answer}
                                          onChange={(e) =>
                                            handleQuestionChange(
                                              section.section,
                                              i,
                                              "answer",
                                              e.target.value
                                            )
                                          }
                                        />
                                        <label>Answer</label>
                                      </div>


                                      {question.que_type ===
                                        "Fill In The Blanks" && (
                                          <>
                                            <p className="text-xs	mt-2 ">
                                              Please add {"@#$"} to separate two
                                              answers.
                                            </p>
                                          </>
                                        )}

                                      <div className="form-floating form-floating-outline mt-4">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="prv_year"
                                          placeholder="Year"
                                          value={
                                            questions[section.section][i]
                                              .prv_year || ""
                                          }
                                          onChange={(e) =>
                                            handleQuestionChange(
                                              section.section,
                                              i,
                                              "prv_year",
                                              e.target.value
                                            )
                                          }
                                        />
                                        <label htmlFor="prv_year">
                                          Previous Year
                                        </label>
                                      </div>
                                    </div>
                                    {/* match the pair ans */}
                                    <div
                                      className="mb-4 "
                                      hidden={
                                        question.que_type !== "Match the pair"
                                      }
                                    >
                                      <div className="form-floating form-floating-outline mt-4">
                                        <h5 className="select-none border border-black opacity-100 bg-[#F4F4F6] p-1 rounded">
                                          <div className="whitespace-pre-wrap break-words">
                                            <MathFormulaViewer
                                              boxSize={screenInWidth}
                                              value={question?.answer
                                                ?.replaceAll("@#$", " => ")
                                                .replaceAll("$#@", " | ")}
                                            ></MathFormulaViewer>
                                          </div>
                                        </h5>
                                        <input
                                          type="text"
                                          className="form-control"
                                          disabled
                                          name="answer2"
                                          hidden
                                          placeholder="Answer"
                                          value={question?.answer
                                            ?.replaceAll("@#$", " => ")
                                            .replaceAll("$#@", " | ")}
                                        />
                                        <label>Answer</label>
                                      </div>
                                    </div>
                                    {question.que_type === "Match the pair" ? (
                                      <div className="form-floating form-floating-outline mt-4">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="prv_year"
                                          placeholder="Year"
                                          value={
                                            questions[section.section][i]
                                              .prv_year || ""
                                          }
                                          onChange={(e) =>
                                            handleQuestionChange(
                                              section.section,
                                              i,
                                              "prv_year",
                                              e.target.value
                                            )
                                          }
                                        />
                                        <label htmlFor="prv_year">
                                          Previous Year
                                        </label>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                    <div className="mt-4">
                                      {/* add option */}
                                      {(question.que_type === "Single Choice" ||
                                        question.que_type ===
                                        "Multiple Choice" ||
                                        question.que_type ===
                                        "Match the pair" ||
                                        question.que_type ===
                                        "Match the pair With Option" ||
                                        question.que_type ===
                                        "Fill In The Blanks With Combo" ||
                                        question.que_type === "Orders") && (
                                          <button
                                            type="button"
                                            className="btn btn-outline-secondary mr-2  "
                                            onClick={() =>
                                              question.que_type ===
                                                "Match the pair" ||
                                                question.que_type ===
                                                "Match the pair With Option"
                                                ? handleAddOptionBtn(
                                                  section.section,
                                                  questionIndex,
                                                  true,
                                                  question.que_type ===
                                                    "Match the pair With Option"
                                                    ? true
                                                    : false
                                                )
                                                : handleAddOptionBtn(
                                                  section.section,
                                                  questionIndex,
                                                  false,
                                                  false
                                                )
                                            }
                                          >
                                            Add Option
                                          </button>
                                        )}

                                      {/* Remove Question */}
                                      {!mcqid && (
                                        <button
                                          type="button"
                                          className="btn btn-outline-danger mx-2 "
                                          onClick={() =>
                                            handleRemoveQuestionBtn(
                                              section.section,
                                              i
                                            )
                                          }
                                        >
                                          Remove Question
                                        </button>
                                      )}
                                    </div>
                                  </form>
                                  {/* <hr className="mb-9 mt-3" /> */}
                                </div>
                              );
                            })}

                          {!mcqid && (
                            <button
                              type="button"
                              className="btn btn-outline-secondary mx-2 mt-2"
                              onClick={() => handleAddQuestionBtn(section)}
                            >
                              Add New Question
                            </button>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ) : (
                <p className="text-center">
                  You cannot add MCQs yet. Please create a section first.
                </p>
              )}

              {questions?.length !== 0 && (
                <>
                  <button
                    type="button"
                    className="btn btn-primary mx-2  mt-2"
                    onClick={handleSubmitBtn}
                  >
                    {mcqid ? "Update" : "Submit"}
                  </button>
                  {/* clear | calcel */}
                  <button
                    type="button"
                    className="btn mx-2 mt-2 btn-secondary"
                    onClick={clearForm}
                  >
                    Cancel
                  </button>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AddMcq;
